// src/frontend/en.json
var setting = {
  preference: {
    notification: {
      sub: "Enable necessary popup notification.",
      title: "Notification popup preference",
      unsaved_screen: {
        sub: "Receive notification when you have unsaved screen.",
        title: "Turn on unsaved screen notification"
      }
    },
    language: {
      subtitle: "Select your favourite language.",
      success_message: "Language preference has been saved.",
      title: "Language"
    },
    unsaved_screen_notification: {
      title: "Don\u2019t show me this notification anymore",
      sub: "If you check this box, you will no longer receive this notification. You can change back this preference on setting page."
    },
    save_changes: "Save changes"
  },
  profile: {
    picture: {
      format_error: "Probably wrong format or size.",
      error: "Image failed to be upload"
    },
    profile_picture_title: "Profile picture",
    confirm_delete_pp: {
      cancel_button: "Cancel",
      delete_button: "Delete account",
      modal_title: "Confirm to delete",
      msg: "To confirm that you want to delete your account, please input your First Name below and click the Delete account button."
    },
    notification: {
      error: "Something happened",
      success: "Successful",
      send_email_duplicated_msg: "A verification email has been sent within one minute, please check your mailbox.",
      send_email_success_msg: "Verification email has been sent, please check your mailbox.",
      wrong_first_name_msg: "Please input your correct first name.",
      change_pp_success_msg: "Your profile picture has been changed successfully."
    },
    email_preferences: {
      marketing: {
        title: "Marketing Emails",
        sub: "Recieve news about the company "
      },
      sub: "Change your email preferences",
      title: "Email preferences",
      technical: {
        sub: "Recieve changelogs when the app has new features",
        title: "Technical emails"
      }
    },
    email_verification_note: {
      button: "Re-send verification code",
      msg: "Please verify your email prior to use the platform.",
      title: "Verify your email"
    },
    profile_picture_title_sub: "Upload your profile picture.",
    delete_my_account_title: "Delete my account",
    personal_info_title: "Personal info",
    delete_my_account_title_sub: "There is no coming back.",
    save_changes: "Save changes",
    confirm_crop: "Confirm",
    personal_info_title_sub: "Update your personal details.",
    click_to_upload: "Click to upload",
    click_to_upload_file_constraints: "or drag and drop PNG, JPEG or JPG"
  },
  seats: {
    am_table: {
      col_name: {
        email: "Account manager email",
        phone: "Account manager phone number",
        name: "Account managers"
      }
    },
    payment_warning: {
      msg: {
        owner: "Please contact your related Account manager.",
        user: "Please contact this enterprise manager.",
        unpaid: "Your enterprise is beyond payment due time. Your subscription needs to be regulated.",
        ended: "Your contract has ended. Have you take all advantages of our services?",
        no_slot: "You are assigned no slot. Please assign yourself the corresponding slot.",
        end_trial: "Your trial period has ended. Have you taken full advantage of our services?"
      },
      button: "Contact customer service",
      title: "There was a problem with your payment"
    },
    plan_card: {
      info: "{{used}} of {{total}} seats used"
    },
    member_table: {
      col_name: {
        role: "Role",
        name: "Name",
        right: "Rights",
        last_activity_date: "Active since"
      }
    },
    delete_user: {
      multiple: {
        confirm_msg: "Are you sure you want to delete these {{number}} users?"
      },
      success_msg: "User has been deleted.",
      confirm_msg: "Are you sure you want to delete this user {{firstName}} {{lastName}}?"
    },
    investor: {
      name: "Investor"
    },
    institutional: {
      name: "Institutional"
    },
    no_slot_warning: {
      title: "You have no plan"
    },
    consumer: {
      name: "Consumer"
    }
  },
  security: {
    link_device: {
      notice: "We will unlink your current device from your account so that you can link your account to a new device. You will be logged out in order to link the new device. The previous TOTP will not work anymore. Please confirm if you want to proceed with the operation.",
      title: "Link to new device",
      subtitle: "Link your account to a new device if you have no access to the current linked device anymore"
    },
    warning_note: {
      content: "It is recommended to re-generate your recovery codes periodically. Proceed the operation with the button below.",
      title: "Re-generate your recovery codes"
    },
    password: {
      title: "Password",
      error_message: "Passwords must be identical",
      disclaimer: "Password must contain at least 8 characters.",
      save_changes: "Save changes",
      subtitle: "Change your password",
      confirm: "Confirm new password",
      success_message: "Password successfully updated !"
    },
    renegerate_code: {
      subtitle: "Your previous recovery codes will not work anymore",
      success: "New recovery codes saved successfully.",
      title: "Regenerate recovery codes"
    }
  },
  organization: {
    details: {
      zip: "ZIP",
      city: "City",
      name: "Company name",
      no_contact_name: "No Contact user assigned",
      title: "Company info",
      phone: "Phone number",
      subtitle: "Update the details of your company.",
      contact_subtitle: "Reference communication user",
      address: "Address",
      country: "Country",
      contact_name: "Contact user",
      email: "Email address"
    },
    notification: {
      update_success: "Updates have been applied successfully."
    },
    logo: {
      title: "Company logo",
      subtitle: "Update the logo of your company."
    }
  },
  connections: {
    options: {
      day: "{{ number }} Day",
      months: "{{ number }} Months",
      year: "{{ number }} Year",
      days: "{{ number }} Days"
    },
    modal: {
      delete: {
        title: "Delete {{ count }} keys",
        subtitle: "Are you sure you want to delete these keys? This action cannot be undone."
      },
      name: {
        placeholder: "Example name",
        label: "Key name"
      },
      warning: {
        title: "Missing values",
        fill: "Please fill all fields"
      },
      delete_confirm: "Delete",
      button_copy: "Copy and close",
      copied: "Key has been copied in clipboard",
      create: {
        title: "Create API key",
        subtitle: "Once created, this key will never be visible again. If compromised\xA0the key needs to be deleted and another one needs to be created."
      },
      expiration: {
        label: "Validity duration",
        placeholder: "Choose a duration"
      },
      button_create: "Create key",
      delete_cancel: "Cancel",
      copy_error: "Error during copy. Please copy manually"
    },
    name: {
      error: "Name is too short"
    },
    tokens_table: {
      col_name: {
        expires_at: "Expiration date",
        name: "Key name",
        enterprise: "Enterprise",
        user: "User",
        created_at: "Creation date"
      }
    },
    table_name: {
      personnal: "Personnal keys",
      app: "App keys"
    },
    days: {
      error: "Expiration days are required"
    }
  },
  collaborator: {
    table_name: "Team members",
    reinvite_user: "An invitation email has been sent successfully.",
    modal: {
      link_companies: {
        success_msg: "Enterprises managed by {{name}} is updated successfully.",
        subtitle: "Company",
        title: "Companies"
      }
    },
    col: {
      companies: "Companies",
      invitation_process: "Invitation process"
    }
  },
  companies: {
    table_name: "Company members"
  },
  company: {
    set_contact_user: {
      success: "User has been set as contact user successfully."
    }
  }
};
var units = {
  official_installed_solar_power: "kW",
  computed_weighted_average_cost_of_debt: "%",
  energy_intensity: "kWh/m\xB2/yr",
  total_area: "m\xB2",
  transport_accessibility: "pts",
  r_revenue_from_postal_and_bank_accounts: "CHF",
  r_estimated_liquidation_taxes: "CHF",
  total_expense_ratio_ref_gav: "%",
  r_resiential_net_rent: "CHF",
  one_month_return: "%",
  idc: "kWh/yr",
  stock_volume: "Units",
  c_market_value: "CHF",
  roi: "%",
  canton_rent: "CHF",
  total_expense_ratio_ref_nav: "%",
  r_plots_net_rent: "CHF",
  distribution_yield: "%",
  r_construction_and_works_fees: "%",
  r_tna_after_distribution: "CHF",
  r_net_assets_at_end_of_the_financial_year: "CHF",
  c_commercial_market_value: "CHF",
  computed_loan_to_value: "%",
  commercial_net_rent_m2: "CHF/m\xB2",
  r_ebit: "CHF",
  c_five_years_total_return: "%",
  r_commercial_cost_price: "CHF",
  target_rent: "CHF",
  reported_market_value: "CHF",
  computed_total_cash_per_share: "CHF",
  rent_per_m2: "CHF/m\xB2",
  beta: "%",
  reported_performance: "%",
  total_tenant_charges: "CHF",
  r_share_buyback_commissions: "%",
  r_nav_before_distribution: "CHF",
  c_nav_after_distribution: "CHF",
  computed_earnings_per_share: "CHF",
  price_per_m2: "CHF/m\xB2",
  r_commercial_spaces_area: "m\xB2",
  r_other_expenses: "CHF",
  potential_charges_per_m2: "CHF",
  r_cost_price_per_m2: "CHF/m\xB2",
  r_roi: "%",
  reported_real_rent: "CHF",
  income_per_taxpayer: "CHF",
  portfolios: {
    floods_50_years: "%",
    hail_hazard_10_years_average: "%",
    avalanches: "%",
    landslides: "%",
    distribution: "%",
    accessibility: "m",
    overbank_sedimentation: "%",
    rockfalls: "%",
    distribution_area: "m\xB2",
    debris_flow: "%"
  },
  climate_risk_index: "%",
  c_three_years_total_return: "%",
  c_nav_compounded: "CHF",
  funds: {
    floods_50_years: "%",
    transactions: {
      value: "CHF"
    },
    sia261: "%",
    landslides: "%",
    rockfalls: "%",
    avalanches: "%",
    overbank_sedimentation: "%",
    debris_flow: "%",
    hail_hazard_10_years: "%"
  },
  five_years_return: "%",
  six_months_return: "%",
  r_valuation_and_auditing_expenses: "CHF",
  r_valuation_expenses: "CHF",
  official_area: "m\xB2",
  c_earnings_per_share: "CHF",
  c_total_market_value: "CHF",
  c_current_agio_after_distribution: "%",
  net_initial_yield: "%",
  c_tna_compounded: "CHF",
  return_on_invested_capital: "%",
  total_idc: "kWh/yr",
  total_co2: "kg/m\xB2/yr",
  press_score: "/10",
  r_profit_and_capital_taxes: "CHF",
  c_median_cost_of_debt: "%",
  r_taxes: "CHF",
  r_roa: "%",
  real_charges_monthly: "CHF",
  r_net_rent_q1: "CHF/m\xB2",
  ter_nav: "%",
  solar_existing_per_m2: "kWh/m\xB2",
  market_dividend: "CHF",
  solar_potential: "kWh/yr",
  c_median_maturity: "yr",
  c_resiential_net_rent: "CHF",
  computed_median_maturity: "yr",
  computed_roe: "%",
  mtd_net_return: "%",
  r_capital_employed: "CHF",
  r_management_fees: "%",
  r_realised_income: "CHF",
  r_tga_after_distribution: "CHF",
  r_tna_before_distribution: "CHF",
  three_months_avg_volume: "Units",
  aged_care: "m",
  computed_roa: "%",
  reported_roe: "%",
  real_charges: "CHF",
  r_coverage_idc: "%",
  market_value_per_m2: "CHF/m\xB2",
  reported_dividend_yield: "%",
  computed_total_area: "m\xB2",
  listed_charges: "CHF",
  c_total_net_rent: "CHF",
  energy: {
    distribution_area: "m\xB2"
  },
  r_administration_of_buildings: "CHF",
  c_market_value_q1: "CHF/m\xB2",
  healthcare: "m",
  r_max_management_fees: "%",
  c_net_rent_q3: "CHF/m\xB2",
  computed_total_dwellings_area: "m\xB2",
  share_class_nav: "CHF",
  cultural_venues: "m",
  estimated_net_rent: "CHF",
  high: "CHF",
  r_mixed_market_value: "CHF",
  secondary_education: "m",
  r_total_properties: "CHF",
  r_tga_before_distribution: "CHF",
  r_total_cost_price: "CHF",
  r_ordinary_income_carried_forward_from_previous_financial_year: "CHF",
  r_residential_net_rent: "CHF",
  r_property_management_fees: "%",
  reported_residential_rental_space: "m\xB2",
  r_cost_price_q1: "CHF/m\xB2",
  estimated_net_rent_monthly: "CHF",
  residential_net_rent_m2: "CHF/m\xB2",
  r_unrealised_gains_and_losses_including_var_est_liq_tax: "CHF",
  rental_space: "m\xB2",
  distribution_value: "CHF",
  lot_area: "m\xB2",
  total_co2_scope_33: "kg/yr",
  r_total_expenses: "CHF",
  r_agio_at_year_end: "%",
  r_property_management_expenses: "CHF",
  r_total_liabilities: "CHF",
  public_utility_density: "%",
  idc_m2: "kWh/m\xB2/yr",
  estimated_total_net_charges: "CHF",
  computed_weighted_average_maturity: "yr",
  r_capital_distribution: "CHF",
  estimated_energy_intensity: "kWh/m\xB2/yr",
  r_mixed_cost_price: "CHF",
  return_on_investment: "%",
  r_net_rent_median: "CHF/m\xB2",
  climate_normals_temperature_1991_2020: "\xB0C",
  r_cost_price_median: "CHF/m\xB2",
  false: "No",
  computed_revenue_per_share: "CHF",
  relative_agio: "%",
  potential_net_rent_monthly: "CHF",
  pts: "pts",
  c_weighted_average_interest_rate: "%",
  unit_outstanding: "Units",
  turnover: "CHF",
  c_mixed_market_value: "CHF",
  real_roa: "CHF",
  c_market_value_median: "CHF/m\xB2",
  charges_per_m2: "CHF/m\xB2",
  r_residential_market_value: "CHF",
  reported_ebit: "CHF",
  r_wault: "yr",
  six_months_avg_volume: "Units",
  r_invested_capital: "CHF",
  c_loan_to_value: "%",
  hist_volatility_30_days: "%",
  r_realised_capital_gains_and_losses: "CHF",
  r_mixed_rental_space: "m\xB2",
  estimated_total_net_rent_per_m2: "CHF",
  reported_payout_ratio: "%",
  r_dividend_distribution: "CHF",
  c_net_rent: "CHF",
  hail_hazard_10_years_average: "cm",
  birth: "%",
  r_real_rent_per_m2: "CHF/m\xB2",
  debt_financing_ratio: "%",
  computed_pe_ratio: "%",
  r_short_term_liabilities: "CHF",
  reported_target_rent: "CHF",
  r_rental_income: "CHF",
  estimated_charges_monthly: "CHF",
  c_weighted_average_maturity: "yr",
  c_pe_ratio: "%",
  five_years_avg_dividend_yield: "%",
  r_payout_ratio: "%",
  r_performance: "%",
  dividend_yield: "%",
  co2_scope_2_per_m2: "kg/m\xB2/yr",
  residential_area: "m\xB2",
  c_total_cash_per_share: "CHF",
  real_net_rent: "CHF",
  job_density: "FTE/ha",
  total_co2_scope_1_2_33: "kg/yr",
  c_debt_ratio: "%",
  computed_total_commercial_area: "m\xB2",
  c_total_agio_at_year_end: "CHF",
  estimated_area: "m\xB2",
  reported_roce: "%",
  r_maintenance_costs: "CHF",
  r_residential_rental_space: "m\xB2",
  r_max_purchase_and_sale_fees: "%",
  accessibility_index: "%",
  cost_price: "CHF",
  potential_market_value_per_m2: "CHF",
  r_share_issue_commissions: "%",
  r_retained_earnings: "CHF",
  r_idc: "kWh/yr",
  death: "%",
  m_market_cap: "CHF",
  swiss_net_rent: "CHF",
  potential_net_rent: "CHF",
  co2: "kg/yr",
  potential_roa: "%",
  r_share_price: "CHF",
  estimated_total_net_charges_per_m2: "CHF",
  estimated_total_income: "CHF",
  one_year_return: "%",
  r_market_value_median: "CHF/m\xB2",
  commercial_spaces_area: "m\xB2",
  computed_payout_ratio: "%",
  share_class_nb: "Units",
  potential_charges_monthly: "CHF",
  climate_normals_sunshine_duration_1991_2020: "hours",
  reported_rental_losses: "%",
  m_share_price: "CHF",
  market_price_var: "%",
  r_roce: "%",
  reported_gross_yield: "%",
  r_auditing_expenses: "CHF",
  m_dividend: "CHF",
  r_net_assets_at_beginning_of_the_financial_year: "CHF",
  last: "CHF",
  r_cost_price_q3: "CHF/m\xB2",
  r_other_rental_space: "m\xB2",
  climate_normals_precipitation_1991_2020: "mm/yr",
  r_residential_area: "m\xB2",
  description: {
    distribution: "%",
    distribution_area: "m\xB2"
  },
  computed_median_cost_of_debt: "%",
  three_years_total_return: "%",
  reported_debt_ratio: "%",
  c_ebit_margin: "%",
  volume: "m\xB3",
  c_roce: "%",
  area: "m\xB2",
  estimated_net_rent_per_m2: "CHF",
  reported_mixed_rental_space: "m\xB2",
  net_rent: "CHF",
  r_residential_cost_price: "CHF",
  r_total_rental_space: "m\xB2",
  shops: "m",
  r_coverage_share_fossil: "%",
  reported_roic: "%",
  r_dividend_from_indirect_rental_income: "CHF",
  r_real_rent: "CHF",
  c_net_rent_q1: "CHF/m\xB2",
  r_co2: "kg/yr",
  hist_volatility_180_days: "%",
  r_dividend_yield: "%",
  population_density: "ppl./ha",
  market_market_cap: "CHF",
  co2_scope_1_2_33_per_m2: "kg/m\xB2/yr",
  share: {
    coverage: "%",
    fossil: "%",
    non_fossil: "%"
  },
  demographic: {
    ages: "%"
  },
  meter: "m",
  surface: "m\xB2",
  r_others_net_rent: "CHF",
  r_total_revenue: "CHF",
  r_long_term_liabilities: "CHF",
  r_absolute_management_fees: "CHF",
  total_expense_ratio_ref_mv: "%",
  road_accessibility: "pts",
  total_co2_scope_1_2_3: "kg/yr",
  r_short_term_interest_bearing_mortgages: "CHF",
  r_debt_ratio: "%",
  potential_total_income: "CHF",
  r_gav_before_distribution: "CHF",
  r_market_value_per_m2: "CHF/m\xB2",
  r_total_market_value: "CHF",
  return_on_capital_employed: "%",
  c_current_agio_compounded: "%",
  c_mixed_net_rent: "CHF",
  ytd_net_return: "%",
  c_current_ratio: "%",
  agio: "%",
  r_custodian_bank_fees: "%",
  total_co2_scope_1_2: "kg/yr",
  r_ter_mv: "%",
  r_other_interest: "CHF",
  r_share_fossil: "%",
  c_tga_compounded: "CHF",
  one_month_avg_volume: "Units",
  reported_rental_area: "m\xB2",
  reported_plots_rental_space: "m\xB2",
  c_payout_ratio: "%",
  reported_commercial_rental_space: "m\xB2",
  r_net_income_available_for_distribution: "CHF",
  five_years_total_return: "%",
  share_class_gav: "CHF",
  c_current_liabilities: "CHF",
  share_market_price: "CHF",
  return_on_equity: "%",
  r_others_cost_price: "CHF",
  estimated_co2_scope_1_2_33_per_m2: "kg/m\xB2/yr",
  potential_net_rent_per_m2: "CHF",
  potential_market_value: "CHF",
  r_dividend_from_capital_gains: "CHF",
  reported_ebit_margin: "%",
  r_idc_per_m2: "kWh/m\xB2/yr",
  c_net_initial_yield: "%",
  r_gross_yield: "%",
  r_total_net_assets: "CHF",
  c_roa: "%",
  debt_ratio: "%",
  r_total_net_rent: "CHF",
  computed_roce: "%",
  duplex: "m\xB2",
  c_total_current_agio_compounded: "CHF",
  c_price_to_book_value: "%",
  c_total_current_agio_after_distribution: "CHF",
  true: "Yes",
  one_year_total_return: "%",
  computed_debt_ratio: "%",
  r_absolute_custodian_bank_fees: "CHF",
  r_ter_gav: "%",
  dividend: "CHF",
  r_purchase_and_sale_fees: "%",
  tx_price: "CHF",
  r_coverage_co2: "%",
  commercial_area: "m\xB2",
  reported_other_rental_space: "m\xB2",
  computed_climate_avg_value: "CHF/year",
  inhabitants_per_room: "ppl.",
  wault: "yr",
  real_market_value: "CHF",
  r_commercial_net_rent: "CHF",
  inhabitants_per_100_m2: "ppl.",
  market_cap: "CHF",
  computed_current_ratio: "%",
  r_ebit_margin: "%",
  reported_roi: "%",
  idc_per_m2: "kWh/m\xB2/yr",
  solar_existing: "kW",
  co2_scope_1_2_per_m2: "kg/m\xB2/yr",
  r_unrealised_capital_gains_and_losses: "CHF",
  total_net_assets: "CHF",
  reported_rental_income: "CHF",
  charges: "CHF",
  c_agio_at_year_end: "%",
  ground_area: "m\xB2",
  roa: "%",
  transport_train: "m",
  r_roic: "%",
  m_dividend_yield: "%",
  office_area: "m\xB2",
  estimated_market_value: "CHF",
  r_property_tax: "CHF",
  roe: "%",
  fifty_two_weeks_low: "CHF",
  ebit_margin: "%",
  c_gav_after_distribution: "CHF",
  co2_scope_1_2_3_per_m2: "kg/m\xB2/yr",
  actual_rental_status_target: "CHF",
  built_up: {
    area: "m\xB2",
    ratio: "%"
  },
  c_weighted_average_cost_of_debt: "%",
  c_residential_market_value: "CHF",
  actual_rental_status_real: "CHF",
  co2_scope_33_per_m2: "kg/m\xB2/yr",
  rate: "%",
  reported_roa: "%",
  low: "CHF",
  fifty_two_weeks_high: "CHF",
  c_others_market_value: "CHF",
  three_years_return: "%",
  primary_education: "m",
  c_roe: "%",
  r_other_revenue: "CHF",
  restaurants: "m",
  three_months_return: "%",
  r_commercial_rental_space: "m\xB2",
  r_total_interest: "CHF",
  r_maintenance_and_repairs_expenses: "CHF",
  early_years: "m",
  market_value: "CHF",
  r_market_value_q3: "CHF/m\xB2",
  r_long_term_interest_bearing_mortgages: "CHF",
  roic: "%",
  ter_mv: "%",
  reported_total_rental_space: "m\xB2",
  listed_net_rent: "CHF",
  computed_ebit_margin: "%",
  r_net_assets_before_estimated_liquidation_taxes: "CHF",
  actual_market_value: "CHF",
  r_max_share_buyback_commissions: "%",
  total_gross_assets: "CHF",
  estimated_charges_per_m2: "CHF",
  r_max_property_management_fees: "%",
  r_nopat: "CHF",
  total_co2_scope_2: "kg/yr",
  market_capitalization: "CHF",
  r_co2_per_m2: "kg/m\xB2/yr",
  one_year_avg_volume: "Units",
  r_plots_rental_space: "m\xB2",
  c_revenue_per_share: "CHF",
  r_roe: "%",
  official_ground_area: "m\xB2",
  green_density: "%",
  r_total_income: "CHF",
  estimated_market_value_per_m2: "CHF",
  open: "CHF",
  c_operating_profit: "CHF",
  yearly_management_fee: "%",
  r_dividend_from_direct_rental_income: "CHF",
  actual_rental_status: "CHF",
  rental_losses: "%",
  r_net_income: "CHF",
  gross_rent: "CHF",
  decibels: "dB",
  ter_gav: "%",
  r_max_construction_and_works_fees: "%",
  estimated_charges: "CHF",
  r_market_maker_fees: "CHF",
  r_rental_losses: "%",
  qtd_net_return: "%",
  industrial_area: "m\xB2",
  divorce: "%",
  r_rental_space: "m\xB2",
  r_market_value_q1: "CHF/m\xB2",
  co2_scope_1_per_m2: "kg/m\xB2/yr",
  r_total_dividend: "CHF",
  reported_capital_employed: "CHF",
  c_gav_compounded: "CHF",
  r_max_share_issue_commissions: "%",
  implied_volatility: "%",
  vwap: "CHF",
  r_market_cap: "CHF",
  real_net_rent_monthly: "CHF",
  potential_charges: "CHF",
  m_share_price_var: "%",
  reported_wault: "yr",
  marriage: "%",
  r_commercial_market_value: "CHF",
  hist_volatility_90_days: "%",
  co2_m2: "kg/m\xB2/yr",
  c_net_rent_median: "CHF/m\xB2",
  r_market_value: "CHF",
  r_target_rent: "CHF",
  reported_cost_price: "CHF",
  minute: "min",
  return_on_asset: "%",
  r_mortgage_interest: "CHF",
  c_market_value_q3: "CHF/m\xB2",
  household_size: "ppl.",
  r_total_cash: "CHF",
  real_rent: "CHF",
  c_commercial_net_rent: "CHF",
  r_mixed_net_rent: "CHF",
  r_max_custodian_bank_fees: "%",
  computed_net_initial_yield: "%",
  emigration: "%",
  hist_volatility_250_days: "%",
  r_other_short_term_liabilities: "CHF",
  market_price: "CHF",
  alpha: "%",
  payout_ratio: "%",
  transport_bus: "m",
  immigration: "%",
  rent_default_rate: "%",
  per_mill: "\u2030",
  reported_share_price: "CHF",
  r_total_area: "m\xB2",
  estimated_total_net_rent: "CHF",
  r_other_net_rent: "CHF",
  r_other_assets: "CHF",
  r_other_long_term_liabilities: "CHF",
  total_co2_scope_1: "kg/yr",
  computed_price_to_book_value: "%",
  r_ter_nav: "%",
  r_building_expenses: "CHF",
  r2: "%",
  five_days_avg_volume: "Units",
  r_net_rent_q3: "CHF/m\xB2",
  r_negative_interest: "CHF",
  r_cost_price: "CHF",
  estimated_roa: "%",
  swiss_francs: "CHF",
  reported_purchase_and_sale_fees: "%",
  reported_long_term_liabilities: "CHF",
  reported_unrealised_gains_and_losses_including_var_est_liq_tax: "CHF",
  computed_three_years_total_return: "%",
  reported_total_revenue: "CHF",
  reported_total_properties: "CHF",
  reported_total_dividend: "CHF",
  computed_gav_after_distribution: "CHF",
  reported_short_term_interest_bearing_mortgages: "CHF",
  reported_net_income_available_for_distribution: "CHF",
  reported_ter_nav: "%",
  reported_absolute_management_fees: "CHF",
  reported_other_interest: "CHF",
  computed_current_agio_after_distribution: "%",
  computed_operating_profit: "CHF",
  reported_nav_before_distribution: "CHF",
  reported_share_issue_commissions: "%",
  reported_other_revenue: "CHF",
  reported_net_income: "CHF",
  computed_five_years_total_return: "%",
  market_last: "CHF",
  reported_ordinary_income_carried_forward_from_previous_financial_year: "CHF",
  reported_tga_before_distribution: "CHF",
  reported_net_assets_before_estimated_liquidation_taxes: "CHF",
  reported_dividend_from_indirect_rental_income: "CHF",
  reported_other_long_term_liabilities: "CHF",
  computed_gav_compounded: "CHF",
  reported_absolute_custodian_bank_fees: "CHF",
  reported_construction_and_works_fees: "%",
  market_five_years_return: "%",
  reported_short_term_liabilities: "CHF",
  reported_total_interest: "CHF",
  reported_ter_mv: "%",
  market_fifty_two_weeks_high: "CHF",
  market_vwap: "CHF",
  computed_tna_compounded: "CHF",
  market_six_months_return: "%",
  reported_total_cash: "CHF",
  market_one_month_return: "%",
  reported_total_income: "CHF",
  listed_total_charges: "CHF",
  reported_custodian_bank_fees: "%",
  reported_total_liabilities: "CHF",
  reported_other_assets: "CHF",
  reported_realised_income: "CHF",
  computed_nav_after_distribution: "CHF",
  reported_auditing_expenses: "CHF",
  reported_unrealised_capital_gains_and_losses: "CHF",
  reported_long_term_interest_bearing_mortgages: "CHF",
  reported_negative_interest: "CHF",
  computed_current_liabilities: "CHF",
  computed_total_current_agio_after_distribution: "CHF",
  market_share_price: "CHF",
  reported_total_expenses: "CHF",
  reported_dividend_from_direct_rental_income: "CHF",
  reported_management_fees: "%",
  market_one_year_total_return: "%",
  reported_valuation_and_auditing_expenses: "CHF",
  reported_net_assets_at_beginning_of_the_financial_year: "CHF",
  market_five_years_total_return: "%",
  reported_building_expenses: "CHF",
  listed_total_net_rent: "CHF",
  reported_property_management_fees: "%",
  reported_market_cap: "CHF",
  reported_other_short_term_liabilities: "CHF",
  reported_dividend_distribution: "CHF",
  reported_mortgage_interest: "CHF",
  reported_taxes: "CHF",
  reported_tna_before_distribution: "CHF",
  market_ytd_net_return: "%",
  reported_nopat: "CHF",
  reported_retained_earnings: "CHF",
  market_one_year_return: "%",
  reported_ter_gav: "%",
  listed_charges_monthly: "CHF",
  market_share_price_var: "%",
  market_fifty_two_weeks_low: "CHF",
  reported_valuation_expenses: "CHF",
  reported_other_expenses: "CHF",
  market_three_years_return: "%",
  reported_capital_distribution: "CHF",
  reported_estimated_liquidation_taxes: "CHF",
  reported_tga_after_distribution: "CHF",
  reported_share_buyback_commissions: "%",
  market_turnover: "CHF",
  market_five_years_avg_dividend_yield: "%",
  computed_current_agio_compounded: "%",
  computed_total_agio_at_year_end: "CHF",
  reported_dividend_from_capital_gains: "CHF",
  reported_administration_of_buildings: "CHF",
  computed_nav_compounded: "CHF",
  computed_total_current_agio_compounded: "CHF",
  market_dividend_yield: "%",
  reported_revenue_from_postal_and_bank_accounts: "CHF",
  reported_maintenance_and_repairs_expenses: "CHF",
  reported_profit_and_capital_taxes: "CHF",
  computed_tga_compounded: "CHF",
  market_three_months_return: "%",
  market_high: "CHF",
  reported_realised_capital_gains_and_losses: "CHF",
  reported_property_tax: "CHF",
  listed_net_rent_monthly: "CHF",
  reported_tna_after_distribution: "CHF",
  reported_agio_at_year_end: "%",
  reported_gav_before_distribution: "CHF",
  percentage: "%",
  computed_total_net_rent: "CHF",
  market_open: "CHF",
  market_low: "CHF",
  market_mtd_net_return: "%",
  market_qtd_net_return: "%",
  reported_heated_area: " m\xB2",
  reported_energy_intensity: "kWh/m\xB2/yr",
  reported_share_fossil: "%",
  reported_co2: "kg/yr",
  reported_coverage_share_fossil: " %",
  computed_energy_source_heating_type_coverage: "%",
  reported_co2_per_m2: "kg/m\xB2/yr",
  estimated_total_market_value: "CHF",
  reported_total_energy: "kWh/yr",
  market_alpha: "%",
  estimated_co2_scope_1_2_per_m2: "kg/m\xB2/yr"
};
var license_agreement = {
  part7: {
    content6: "enters into or proposes any composition or arrangement with its creditors generally; or",
    content8: "Each party may terminate the license by written notice to the other party in the event that the other party has breached a material term of this EULA and the breach was not cured within thirty (30) days of its receipt of written notice by the concerned party. Such termination will not trigger any entitlement from you to get refunded.",
    content3: "is unable to pay its debts or becomes insolvent;",
    content1: "The license is valid for the term referred to in the relevant TD. Absent such terms set out in a TD, the license is valid for one year as of the date of signature of the TD by both parties and shall automatically renew for successive one-year periods unless otherwise terminated by either party with three month\u2019s prior written notice.",
    title: "7. Term\xA0",
    content4: "is the subject of an order made or a resolution passed for the administration, winding-up or dissolution (otherwise than for the purpose of a solvent amalgamation or reconstruction);",
    content5: "has an administrative or other receiver, manager, trustee, liquidator, administrator, or similar officer appointed over all or any substantial part of its assets;",
    content10: "Termination of this EULA will not affect any accrued claims, rights or liabilities of the parties, nor will it affect the continuation in force of the following clauses: 6, 11 and 13.",
    content2: "Each party has the right, without prejudice to its other rights or remedies, to terminate the license immediately by written notice to the other party, if the other party:",
    content7: "is the subject of any events or circumstances analogous to any of the foregoing in any applicable jurisdiction.",
    content9: "QUANTHOME may further terminate the license subject to thirty (30) days prior written notice as a result of your use of the APP to breach any applicable law related to the use of the APP, notably the ones of Switzerland, or if QUANTHOME reasonably considers its brands or reputation to be damaged as a result of your action or omission. Such termination will not trigger any entitlement from you to get refunded."
  },
  part8: {
    content7: "QUANTHOME SHALL HAVE NO RESPONSIBILITY IF THE APP HAS BEEN ALTERED IN ANY WAY, OR FOR ANY FAILURE THAT ARISES OUT OF THE USE OF THE APP WITH OTHER THAN A RECOMMENDED HARDWARE CONFIGURATION, PLATFORM OR OPERATING SYSTEM.",
    content6: "NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY QUANTHOME, ITS DEALERS, DISTRIBUTORS, AGENTS OR EMPLOYEES SHALL CREATE A WARRANTY OR IN ANY WAY INCREASE THE SCOPE OF ANY WARRANTY PROVIDED HEREIN.",
    content4: "THE CONTENT OF THE APP MAY INCLUDE INFORMATION OBTAINED FROM THIRD-PARTY SOURCES, AND QUANTHOME ASSUMES NO RESPONSIBILITY OR LIABILITY FOR THE ACCURACY OR COMPLETENESS OF SUCH INFORMATION.",
    content5: "ALSO, THERE IS NO WARRANTY OF NON-INFRINGEMENT AND TITLE OR QUIET ENJOYMENT. QUANTHOME DOES NOT WARRANT THAT THE APP IS ERROR-FREE OR WILL OPERATE WITHOUT INTERRUPTION. NO RIGHTS OR REMEDIES WILL BE CONFERRED ON YOU. THE APP IS NOT DESIGNED, INTENDED OR LICENSED FOR USE IN HAZARDOUS ENVIRONMENTS REQUIRING FAIL-SAFE CONTROLS, INCLUDING WITHOUT LIMITATION, THE DESIGN, CONSTRUCTION, MAINTENANCE OR OPERATION OF NUCLEAR FACILITIES, AIRCRAFT NAVIGATION OR COMMUNICATION SYSTEMS, AIR TRAFFIC CONTROL, AND LIFE SUPPORT OR WEAPONS SYSTEMS. QUANTHOME SPECIFICALLY DISCLAIMS ANY EXPRESS OR IMPLIED WARRANTY OF FITNESS FOR SUCH PURPOSES.",
    content3: "THE CONTENT OF THE APP DOES NOT PURPORT TO BE COMPREHENSIVE OR TO SUBSTITUTE FOR PROFESSIONAL INVESTMENT, TAX, LEGAL, OR OTHER ADVICE. YOU SHOULD CONSULT WITH YOUR FINANCIAL, TAX, OR LEGAL ADVISORS FOR INFORMATION CONCERNING YOUR INDIVIDUAL SITUATION.",
    title: "8. WARRANTY DISCLAIMER\xA0",
    content1: "YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT THE USE OF THE APP IS AT YOUR OWN AND SOLE RISK. THE APP HAS BEEN PROVIDED \u201CAS IS\u201D WITHOUT WARRANTY OF ANY KIND BY QUANTHOME, ITS DIRECTORS, EMPLOYEES, AGENTS AND/OR PARTNERS. TO THE MAXIMUM EXTENT ALLOWED BY APPLICABLE LAW, QUANTHOME AND ITS SUPPLIERS AND PARTNERS EXPRESSLY DISCLAIM ALL WARRANTIES AND REPRESENTATIONS, WHETHER EXPRESS, IMPLIED, OR OTHERWISE, INCLUDING THE WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.",
    content2: "THE CONTENT PROVIDED THROUGH THE APP IS NOT TO BE CONSTRUED AS INVESTMENT ADVICE, RECOMMENDATION, OR AN OFFER TO BUY OR SELL ANY FINANCIAL INSTRUMENTS OR TO PARTICIPATE IN ANY PARTICULAR TRADING STRATEGY. ANY RELIANCE ON THE CONTENT IS AT YOUR SOLE RISK."
  },
  part11: {
    content11: "The processing of these Data will take place in accordance with our Privacy Policy that can be found here.",
    content4: "crypted password",
    content7: "login and logout activity (QUANTHOME reserves the right to log and monitor users\u2019 general activity on our platform, including but not limited to the routes navigated, actions performed, and pages visited, for the purpose of enhancing user experience, ensuring security, and improving our services)",
    content2: "full name",
    content8: "APP and device errors, failures and crashes",
    content3: "work email",
    content1: "You agree that the only personal data to be processed by QUANTHOME as a result of your access and use of the APP will consist of:",
    content9: "for each user, at any time (the \u201C<strong>Data</strong>\u201D).\xA0",
    content6: "IP and user agent for each session",
    content10: "Additional information may be collected and processed in the context of specific TDs and with the express consent of the Client.",
    content5: "ID and name of entity for which the user is administrator, member or operator",
    title: "11. Data Protection\xA0"
  },
  part12: {
    content7: "Nothing contained in this EULA shall be construed to create a partnership, agency, joint venture, or employer/employee relationship between the parties. Neither party has the authority to assume or create any obligation or responsibility, express or implied, on behalf of, or in the name of, the other party or to bind such other party in any way.",
    content6: "All notices under the EULA must be in writing and sent to the business address specified for the EULA, unless a party designates in writing a different address. The parties consent to the use of electronic means and facsimile transmissions for communications as a signed writing. Any reproduction of the EULA made by reliable means is considered an original.",
    content2: "The provisions of this EULA are severable, such that the invalidity of any term of this EULA declared by a court of competent jurisdiction shall not affect the validity of any of the other terms. Any such invalid term shall be subject to partial enforcement in line with the original common intent of the parties to the maximum extent permitted under applicable law.",
    content1: "This EULA or related TD may not be assigned by you without the prior written consent of QUANTHOME.",
    content5: "In the event of force majeure or other exceptional events (\u201C<strong>Force Majeure</strong>\u201D) for which QUANTHOME is not responsible which make it impossible or substantially more difficult to have the APP operate, QUANTHOME may restrict or suspend the APP during the duration of such obstacle or terminate the EULA. Force Majeure includes, but is not limited to, war, unrest, rebellion, acts of sabotage and similar events, strikes or other industrial conflicts, newly enacted laws and regulations, delay caused by actions or omissions on the part of a government/authorities, fire, explosion or other unavoidable events, epidemic, pandemic, flood, storm, earthquake or other exceptional natural events. Under no circumstances shall QUANTHOME be held liable for claims related to non-performance, improper performance or belated performance of contractual obligations as a result of such Force Majeure events.\xA0",
    title: "12. Miscellaneous\xA0",
    content4: "The failure by a party to insist upon strict performance of any provision hereof shall not constitute a waiver of such provision, or a waiver for any subsequent breach of said provision. All waivers must be in writing to be enforceable hereunder.",
    content3: "This EULA constitutes the entire agreement between the parties concerning the subject matter hereof and supersedes all prior agreements and communications, whether oral or written, between the parties relating to the subject matter hereof, and all past courses of dealing or industry custom. As used herein, the term, \u201Cincluding\u201D means \u201Cincluding but not limited to\u201D."
  },
  part9: {
    content4: "THE FOREGOING LIMITATIONS ON LIABILITY ARE INTENDED TO APPLY TO ALL PROVISIONS OF THIS EULA.",
    title: "9. LIMITATION OF LIABILITY\xA0",
    content3: "UNDER NO CIRCUMSTANCES SHALL QUANTHOME OR ITS PARTNERS BE LIABLE FOR ANY UNAUTHORIZED USE OF THE APP TO DEVELOP, DISTRIBUTE OR USE ANY MATERIAL THAT IS DEFAMATORY, SLANDEROUS, LIBELOUS OR OBSCENE, THAT PORTRAYS ANY PERSON IN A FALSE LIGHT OR CONSTITUTES AN INVASION OF ANY RIGHT TO PRIVACY, THAT INFRINGES ANY THIRD PARTY\u2019S RIGHTS OR THAT IS CONTRARY TO ANY FOREIGN, FEDERAL OR LOCAL STATUTE OR REGULATION.",
    content1: "TO THE EXTENT PERMITTED BY APPLICABLE LAW, NEITHER QUANTHOME NOR ITS SUPPLIERS AND PARTNERS SHALL BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, COVER OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR THE INABILITY TO USE EQUIPMENT OR ACCESS DATA, LOSS OF BUSINESS, LOSS OF PROFITS, BUSINESS INTERRUPTION OR THE LIKE), ARISING OUT OF THE USE OF, OR INABILITY TO USE, THE APP AND BASED ON ANY THEORY OF LIABILITY INCLUDING BREACH OF CONTRACT, BREACH OF WARRANTY, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF QUANTHOME OR ITS REPRESENTATIVES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.",
    content2: "QUANTHOME HAS NO FINANCIAL LIABILITY to the largest extent permissible under applicable law."
  },
  part1: {
    title: "1. Definitions\xA0",
    content2: "\u201C<strong>EULA</strong>\u201D means this end user license agreement;\xA0",
    content1: "\u201C<strong>APP</strong>\u201D means the web application supplied by QUANTHOME herewith, and, if applicable, the corresponding documentation, associated media, printed materials, and online or electronic documentation, and all updates or upgrades of the above that are provided to you;\xA0",
    content3: "\u201C<strong>QUANTHOME</strong>\u201D means Quanthome SA, IDE: CHE-321.617.538, with registered seat in Lausanne, Switzerland.\xA0"
  },
  part2: {
    content: "QUANTHOME hereby grants you a limited, non-exclusive, non-transferable, non-sublicensable right to use the APP for a one-off period of 365 days following the purchase of an annual license pursuant to the transaction document set forth in annex (\u201C<strong>TD</strong>\u201D).\xA0",
    title: "2. License to use the APP\xA0"
  },
  part13: {
    title: "13. Governing Law and Jurisdiction\xA0",
    content1: "This EULA shall be governed by the substantive laws of Switzerland, without giving effect to principles of conflict of laws, in particular excluding the United Nations Convention on the International Sale of Goods. The same shall apply to any TD entered into under this EULA.",
    content2: "Any dispute resulting of or related to this EULA shall be subject to the exclusive jurisdiction of the ordinary courts of Lausanne, Switzerland, to which the parties hereby irrevocably agree to be submitted. The same shall apply to any TD entered into under this EULA."
  },
  part3: {
    content1: "You may not reproduce in any way or distribute copies of the APP, make available the APP in any way to third parties, upload the APP on any website or electronically transfer the APP from one computer to another or over a network, except as expressly authorized under the terms of this EULA.",
    content5: "You may not share your account with any other person or entity, thereby exceeding your account user allowance.",
    content6: "You may not modify the APP or create derivative works based upon the APP.",
    content3: "You may not sell, rent, lease, loan or sublicense the APP.",
    content2: "You may not alter, merge, modify, adapt or translate the APP, or decompile, reverse engineer, disassemble, or otherwise reduce the APP to a human-perceivable form or undertake any activity intended to bypass, defeat or otherwise circumvent (or having the effect of facilitating, modifying, or assisting the bypassing, defeating or circumventing of) the proper and/or secure operation of the APP or breach any patent held or patent application deposited by QUANTHOME in any way.",
    content4: "You may not distribute, rent, lease or sell the results of the use of the APP (in particular the data).",
    title: "3. License Restrictions\xA0"
  },
  part6: {
    content1: "You agree to pay all applicable charges specified in a TD and charges for use in excess of these authorizations. Amounts are due upon receipt of the invoice and payable within 30 days of the invoice date to an account specified by QUANTHOME and late payment fees may apply. QUANTHOME does not give credits or refunds for any prepaid, one-time charges, or other charges already due, paid or committed. QUANTHOME may change charges upon renewal on a TD subject to forty-five (45) days\u2019 prior written notice to you.",
    content2: "QUANTHOME will invoice the charges due on a yearly basis at the beginning of each contract term, except for over usage which will be invoiced in arrears if need be.",
    title: "6. Charges and payment for TD\xA0"
  },
  part4: {
    content1: "The foregoing license gives you limited license to use the APP and no other license or right is hereby granted either expressly or by implication. QUANTHOME and its suppliers and partners retain all rights, titles and interests, including all copyrights and intellectual property rights, in and to, the APP and all copies thereof.",
    title: "4. Ownership\xA0",
    content2: "All rights not specifically granted in this EULA, including but not limited to national and international copyrights, are reserved by QUANTHOME, its suppliers and its partners."
  },
  update: {
    title: "We have updated our license agreement."
  },
  input: {
    label: "I agree to the license agreement.",
    title: "Please confirm that you have read and agree to our <span>license agreement</span>.",
    error: "It is mandatory to agree to the license agreement in order to access the app."
  },
  part5: {
    content1: "Pursuant to the terms of the present EULA, you agree to abide by the rules and policies established from time to time by QUANTHOME relating to the APP\u2019s updates and security components. QUANTHOME commits to apply such rules and policies in a non-discriminatory manner to users of the APP, such rules including for example but without limitation required or automated updates, modifications and/or installations of the APP to address security, interoperability and/or performance issues.",
    content2: "These updates, modifications and the like may occur on a periodic or as needed basis, without prior notice to you.",
    title: "5. Updates, Security and Revocation\xA0"
  },
  part10: {
    content2: "The limitations or exclusions of warranties and liability contained in this EULA do not affect or prejudice the statutory rights of a consumer.",
    title: "10. Consumer End Users Only\xA0",
    content1: "The limitations or exclusions of warranties and liability contained in this EULA do not affect or prejudice the statutory rights of a consumer."
  },
  title: "End user license agreement for web application from Quanthome SA",
  intro: {
    first: "IMPORTANT: THIS END USER LICENSE AGREEMENT (<strong>EULA</strong>) IS A BINDING LEGAL AGREEMENT BETWEEN YOU (EITHER AN INDIVIDUAL OR AN ENTITY) AND QUANTHOME. READ IT CAREFULLY BEFORE USING THE WEB APPLICATION (<strong>APP</strong>). IT PROVIDES A LICENSE TO USE THE APP AND CONTAINS WARRANTY INFORMATION AND LIABILITY DISCLAIMERS. BY SELECTING THE \u201CI ACCEPT\u201D BUTTON AND USING THE APP, YOU ARE CONFIRMING YOUR ACCEPTANCE OF THE APP AND AGREEING TO BECOME BOUND BY THE TERMS OF THIS EULA.\xA0",
    second: "IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS, THEN DO NOT USE THE APP."
  }
};
var funds = {
  environmental: {
    risks: {
      computed_climate_avg_rate: {
        key: "Total per 1\u2019000 expected annual damage",
        description: "Expected average damage caused every year to the fund's buildings by hail, flood and windstorm combined, per 1'000 CHF"
      },
      computed_climate_avg_value: {
        description: "Expected total damage in CHF caused every year to the fund's buildings by hail, flood and windstrom combined",
        key: "Total expected damage in CHF per year"
      }
    },
    title: "Environmental",
    hail_hazard_10_years: "Hail size",
    climate: {
      risk: {
        description: "The climate risk index is based on the exposure of buildings within investment vehicles to different environmental risks. Each risk has an equal weight in the index"
      }
    },
    building_with_solar_existing: "Buildings with solar panels",
    share: {
      fossil: "Share fossil",
      r_coverage_share_fossil: "Coverage",
      coverage: "Coverage rate",
      r_share_fossil: "Share fossil",
      non_fossil: "Share non-fossil"
    },
    tile: {
      environmental_risks_details: "Details",
      environmental_risks_total: "Total",
      energy_source: "Energy source",
      environmental_risks: "Environmental risks",
      solar: "Solar",
      climate_risk_index: "Climate risk index",
      share: "Energy share",
      idc_and_co2: "Energy intensity & CO\u2082"
    },
    solar_potential: "Total solar potential",
    estimated_co2_emission_per_m2: "CO\u2082 per m\xB2",
    idc: {
      idc_per_m2: {
        description: "Energy intensity measures the estimated energy consumption per square meter of heating surface over one year for each building in the investment vehicle. The overall energy intensity for the vehicle is then calculated with a weighted average of the buildings, where each building is weighted according to its heating surface.",
        key: "Energy intensity"
      },
      r_idc: "Total energy",
      r_coverage_idc: "Coverage",
      title: "Energy intensity",
      total_idc: "Total energy",
      r_idc_per_m2: "Energy intensity"
    },
    avalanches: "Avalanches",
    estimated_idc_per_m2: "Energy intensity per m\xB2",
    computed_windstorm_avg_rate: "Windstorm",
    total_estimated_idc: "Total Energy intensity",
    sia261: "SIA261",
    computed_hail_avg_rate: "Hail",
    co2: {
      co2_scope_1_2_33_per_m2: "CO\u2082 (scope 1 + 2 + 3.3)",
      total_co2_scope_1_2_33: "Total CO\u2082 (scope 1 + 2 + 3.3)",
      title: "CO\u2082 emissions",
      co2_scope_1_per_m2: "CO\u2082 (scope 1)",
      r_coverage_co2: "Coverage",
      co2_scope_2_per_m2: "CO\u2082 (scope 2)",
      co2_scope_1_2_per_m2: {
        key: "CO\u2082 (scope 1 + 2)",
        description: "CO\u2082 emissions are computed using the energy intensity multiplied by the REIDA coefficient for each building. The overall CO\u2082 emissions for the vehicle are then calculated with a weighted average of the buildings"
      },
      r_co2_per_m2: "CO\u2082 emissions",
      co2_scope_33_per_m2: "CO\u2082 (scope 3.3)",
      r_co2: "Total CO\u2082 emissions",
      total_co2_scope_1_2: "Total CO\u2082 (scope 1 + 2)"
    },
    risk: {
      title: "Risk"
    },
    total_estimated_co2_emission: "Total CO\u2082",
    overbank_sedimentation: "Overbank sedimentation",
    energy: {
      title: "Energy"
    },
    floods_50_years: "Floods",
    landslides: "Landslides",
    debris_flow: "Debris flow",
    evolution: {
      chart: {
        title: "Chart"
      },
      title: "Evolution"
    },
    press_score: "Environmental PRESS score:",
    computed_flood_avg_rate: "Flood",
    solar_existing: "Installed solar power",
    rockfalls: "Rockfalls",
    solar_existing_per_m2: "Installed solar power per m\xB2"
  },
  financials: {
    metrics: {
      c_revenue_per_share: "Revenue per share",
      title: "Financial Metrics",
      c_operating_profit: "Operating profit",
      r_dividend_from_direct_rental_income: "Dividend from direct rental income",
      five_years_avg_dividend_yield: "5 Year avg. div. yield",
      c_earnings_per_share: "Earnings per share",
      r_total_dividend: "Total dividend",
      r_roi: "ROI",
      r_dividend_yield: "Dividend yield",
      r_roic: "ROIC",
      r_debt_ratio: "Debt ratio",
      c_net_initial_yield: "Net initial yield",
      c_ebit_margin: "EBIT margin",
      income_statement: {
        title: "Income Statement Metrics",
        chart_title: "Income statement visualisation"
      },
      quantitative_valuation_ratios: {
        title: "Quantitative Valuation Ratios"
      },
      r_wault: "WAULT",
      ratios: {
        title: "Ratios"
      },
      r_performance: "Performance",
      r_payout_ratio: "Payout ratio",
      c_roa: "ROA",
      c_current_ratio: "Current Ratio",
      c_agio_at_year_end: "Agio at year-end",
      m_dividend_yield: "Dividend yield",
      c_pe_ratio: "P/E ratio",
      r_rental_losses: "Rental losses",
      r_dividend_from_capital_gains: "Dividend from capital gains",
      c_total_cash_per_share: "Total cash per share",
      c_debt_ratio: "Debt ratio",
      r_dividend_from_indirect_rental_income: "Dividend from indirect rental income",
      c_price_to_book_value: "Price-to-book value",
      liquidity: {
        title: "Liquidity Metrics"
      },
      c_roe: "ROE",
      balance_sheet: {
        chart_title: "Balance sheet visualisation"
      },
      c_roce: "ROCE",
      c_loan_to_value: "Loan-to-value",
      c_payout_ratio: "Payout ratio",
      r_estimated_liquidation_taxes: "Estimated liquidation taxes",
      r_roe: "ROE",
      c_current_liabilities: "Current liabilities",
      c_weighted_average_cost_of_debt: "Weighted average interest rate",
      r_ebit_margin: "EBIT margin",
      dividends: {
        title: "Dividends"
      },
      c_weighted_average_maturity: "Weighted average maturity"
    },
    portfolio: {
      r_total_market_value: "Total",
      r_commercial_cost_price: "Commercial",
      c_market_value_median: "Median",
      c_commercial_market_value: "Commercial",
      r_cost_price_q1: "Q1",
      r_residential_market_value: "Residential",
      r_residential_cost_price: "Residential",
      r_commercial_market_value: "Commercial",
      r_market_value_median: "Median",
      r_others_cost_price: "Others",
      c_others_market_value: "Others",
      c_total_market_value: "Total",
      r_cost_price: {
        title: "Cost price of buildings reported"
      },
      r_market_value_q3: "Q3",
      c_mixed_market_value: "Mixed",
      title: "Portfolio Value",
      computed_market_value: {
        title: "Market value of buildings"
      },
      r_cost_price_by_m2: {
        title: "Cost price per m\xB2 reported"
      },
      c_cost_price_by_m2: {
        title: "Cost price per m\xB2"
      },
      r_plots_cost_price: "Plots",
      r_mixed_market_value: "Mixed",
      c_residential_market_value: "Residential",
      r_cost_price_q3: "Q3",
      r_plots_market_value: "Plots",
      computed_market_value_by_m2: {
        title: "Market value per m\xB2"
      },
      c_market_value: {
        title: "Market value of buildings estimated"
      },
      r_other_market_value: "Others",
      r_total_cost_price: "Total",
      c_market_value_by_m2: {
        title: "Market value per m\xB2"
      },
      c_cost_price: {
        title: "Cost price of buildings"
      },
      c_market_value_q3: "Q3",
      r_market_value_by_m2: {
        title: "Market value per m\xB2 reported"
      },
      c_market_value_q1: "Q1",
      r_market_value_q1: "Q1",
      r_cost_price_median: "Median",
      r_market_value: {
        title: "Market value of buildings reported"
      },
      r_mixed_cost_price: "Mixed",
      r_other_cost_price: "Others"
    },
    accounting: {
      balance_sheet: {
        table_title: "Balance sheet table"
      },
      income_statement: {
        table_title: "Income statement table"
      }
    },
    tile: {
      trade: "Trade statistics",
      return: "Return",
      stock_history: "Stock price history",
      charges: "Tenant charges",
      evolution: "Evolution",
      risk_statistics: "Risk statistics",
      key_performance: "Key performance",
      dividends: "Dividends",
      rental_income: "Rental income",
      key_financials_per_share: "Financial performance (per share)",
      losses: "Losses",
      key_financials: "Financial performance (total)",
      fees: "Fees",
      measures: "Valuation measures"
    },
    performance: {
      year_end_total_value: {
        title: "Total value at year end"
      },
      c_current_agio_before_distribution: "Agio before distribution",
      r_tna_after_distribution: "TNA after distribution",
      c_current_agio_after_distribution: "Agio after distribution",
      c_tna_compounded: "TNA compounded",
      r_tga_after_distribution: "TGA after distribution",
      r_gav_before_distribution: "GAV before distribution",
      r_market_cap: "Market capitalisation",
      current_total_value: {
        title: "Current total value"
      },
      m_share_price: "Share price",
      c_gav_compounded: "GAV compounded",
      r_share_price: "Share price",
      r_tna_before_distribution: "TNA before distribution",
      m_market_cap: "Market capitalisation",
      m_dividend_yield: "Dividend yield",
      r_nav_before_distribution: "NAV before distribution",
      c_total_current_agio_compounded: "Total agio compounded",
      c_total_current_agio_after_distribution: "Total agio after distribution",
      r_tga_before_distribution: "TGA before distribution",
      r_agio_at_year_end: "Agio",
      c_gav_after_distribution: "GAV after distribution",
      c_current_agio_compounded: "Agio compounded",
      c_total_agio_at_year_end: "Agio",
      c_nav_after_distribution: "NAV after distribution",
      title: "Performance",
      c_nav_compounded: "NAV compounded",
      current_value_per_share: {
        title: "Current value per share"
      },
      c_tga_compounded: "TGA compounded",
      year_end_value_per_share: {
        title: "Value per share at year end"
      }
    },
    rental_income: {
      c_total_net_rent: "Total",
      c_commercial_net_rent: "Commercial",
      computed_by_m2: {
        title: "Rental income per m\xB2"
      },
      estimated_by_m2: {
        title: "Rental income per m\xB2"
      },
      title: "Rental income",
      reported_by_m2: {
        title: "Rental income per m\xB2 reported"
      },
      c_net_rent_q1: "Q1",
      r_others_net_rent: "Others",
      computed: {
        title: "Rental income"
      },
      r_other_net_rent: "Others",
      r_net_rent_q3: "Q3",
      r_plots_net_rent: "Plots",
      r_commercial_net_rent: "Commercial",
      r_net_rent_median: "Median",
      r_total_net_rent: "Total",
      r_resiential_net_rent: "Residential",
      reported: {
        title: "Rental income reported"
      },
      r_net_rent_q1: "Q1",
      c_net_rent_median: "Median",
      r_mixed_net_rent: "Mixed",
      c_mixed_net_rent: "Mixed",
      c_resiential_net_rent: "Residential",
      c_net_rent_q3: "Q3",
      estimated: {
        title: "Rental income"
      }
    },
    stock: {
      three_months_avg_volume: "Average volume 3-Month",
      alpha: "Alpha (5Y Monthly)",
      one_year_avg_volume: "Average volume 1-Year",
      evolution: {
        title: "Evolution"
      },
      hist_volatility_250_days: "Historical Volatility 1-Year",
      volume: "Last volume",
      six_months_avg_volume: "Average volume 6-Month",
      five_years_return: "5-Year",
      fifty_two_weeks_low: "52-Week Low",
      qtd_net_return: "Quarter-to-Date (QTD)",
      trade: {
        title: "Trade Statistics"
      },
      hist_volatility_180_days: "Historical Volatility 6-Month",
      five_days_avg_volume: "Average volume 5-Days",
      unit_outstanding: "Outstanding shares",
      title: "Stock performance",
      six_months_return: "6-Month",
      hist_volatility_30_days: "Historical Volatility 1-Month",
      one_year_return: "1-Year",
      three_months_return: "3-Month",
      fifty_two_weeks_high: "52-Week High",
      three_years_return: "3-Year",
      ytd_net_return: "Year-to-Date (YTD)",
      mtd_net_return: "Month-to-Date (MTD)",
      one_month_return: "1-Month",
      history: {
        title: "Stock Price History"
      },
      sharpe_ratio: "Sharpe ratio",
      hist_volatility_90_days: "Historical Volatility 3-Month",
      one_month_avg_volume: "Average volume 1-Month",
      beta: "Beta (5Y Monthly)",
      risk: {
        title: "Risk Statistics"
      },
      turnover: "Turnover",
      r2: "R\xB2"
    },
    fees: {
      r_ter_nav: "TERrefNAV",
      r_property_management_fees: "Property management fees",
      r_ter_mv: "TERrefMV",
      r_ter_gav: "TERrefGAV",
      maximum: {
        title: "Maximum Fees"
      },
      r_max_share_buyback_commissions: "Share buyback commission",
      r_max_management_fees: "Management fees",
      r_max_construction_and_works_fees: "Construction and works",
      r_max_purchase_and_sale_fees: "Purchase and sale of real estate",
      r_custodian_bank_fees: "Custodian bank fees",
      r_construction_and_works_fees: "Construction and works",
      effective: {
        title: "Effective Fees"
      },
      r_max_property_management_fees: "Property management fees",
      title: "Fees",
      r_purchase_and_sale_fees: "Purchase and sale of real estate",
      r_max_share_issue_commissions: "Share issue commission",
      r_share_issue_commissions: "Share issue commission",
      r_share_buyback_commissions: "Share buyback commission",
      r_management_fees: "Management fees",
      r_max_custodian_bank_fees: "Custodian bank fees"
    },
    cost_price: {
      title: "Cost Price"
    },
    charges: {
      title: "Tenant charges"
    },
    title: "Financials",
    side_menu: {
      hover_label: "Variation"
    },
    trading: {
      title: "Trading Information"
    },
    market_value: {
      title: "Market value"
    },
    income_statement: {
      title: "Income Statement"
    },
    highlights: {
      title: "Financial highlights"
    },
    stock_performance: {
      title: "Stock Performance"
    },
    evolution: {
      chart: {
        title: "Chart"
      },
      title: "Evolution"
    },
    debts: {
      title: "Debt Structure"
    },
    report: {
      annual: "annual",
      semi_annual: "semi-annual"
    },
    balance_sheet: {
      title: "Balance Sheet"
    },
    revenue: {
      title: "Revenue"
    },
    benchmark: "Select a benchmark"
  },
  performance: {
    total_expense_ratio_ref_mv: "Total expense ratio (TER_MV)",
    payout_ratio: "Payout ratio",
    wault_suffix: "years",
    hist_volatility_250_days: "Historical Volatility 1-Year",
    rent_default_rate: "Rental losses",
    hist_volatility_90_days: "Historical Volatility 3-Month",
    fifty_two_w_high: "52-Week High",
    total_net_assets: "Total net assets",
    return_on_asset: "ROA",
    market_capitalization: "Market capitalisation",
    yearly_management_fee: "Management fee",
    dividend: "Last dividend",
    three_m_return: "3-Month",
    five_y_avg_dividend_yield: "5Y avg dividend yield",
    dividend_yield: "Dividend yield",
    volume: "Average Volume",
    fifty_two_w_low: "52-Week Low",
    alpha: "Alpha (5Y Monthly)",
    one_m_return: "1-Month",
    return_on_equity: "Return on equity (ROE)",
    turnover: "Turnover",
    volume_suffix: "Units",
    return_on_capital_employed: "ROCE",
    relative_agio: "Agio",
    three_y_return: "3-Year",
    debt_financing_ratio: "Debt ratio",
    distribution_yield: "Distribution yield",
    return_on_investment: "Return on investment (ROI)",
    return_on_invested_capital: "Return on invested capital (ROIC)",
    beta: "Beta (5Y Monthly)",
    mtd_net_return: "Month-to-date (MTD)",
    one_y_return: "1-Year",
    total_expense_ratio_ref_nav: "Total expense ratio (TER_NAV)",
    total_gross_assets: "Total gross asset",
    ebit_margin: "EBIT margin",
    ytd_net_return: "Year-to-date (YTD)",
    hist_volatility_30_days: "Historical Volatility 1-Month",
    hist_volatility_180_days: "Historical Volatility 6-Month",
    r2: "R\xB2",
    total_expense_ratio_ref_gav: "Total expense ratio (TER_GAV)",
    qtd_net_return: "Quarter-to-date (QTD)",
    wault_label: "Weighted average unexpired lease term (WAULT)"
  },
  noright: {
    title: "REIVs",
    subtitle: "This feature requires a more complete plan.",
    button: "Contact account manager",
    details: "The Real Estate Investment Vehicles (REIVs) module shows comprehensive information about wide range of swiss real estate entities."
  },
  governance: {
    tile: {
      certification: "Certification",
      press_score: "PRESS \u2013 Public Real Estate Sustainability Scores",
      valuation_expert: "Valuation experts",
      property_management: "Property management",
      ownership: "Ownership",
      auditors: "Auditors",
      minergie: "Minergie"
    },
    manager: "Fund manager",
    certificates_rating: {
      title: "Certificates and rating"
    },
    social: "Social",
    governance: "Governance",
    custodian_bank: "Custodian bank",
    esg: "ESG",
    press_score: "Governance PRESS score:",
    director: "Fund director",
    ranking: "Ranking",
    title: "Governance",
    minergie_buildings: "Proportion of minergie buildings",
    organisation: {
      title: "Organisation"
    },
    environmental: "Environmental"
  },
  administrative: {
    custodian_bank: "Custodian bank",
    benchmark_bloomberg_ticker: "Benchmark Ticker",
    benchmark: "Benchmark",
    manager: "Fund manager",
    name: "Share Registry",
    director: "Fund director",
    domicile: "Domicile of the fund"
  },
  social: {
    transport_accessibility: {
      road_accessibility: {
        title: "By road",
        description: "Average of the accessibility score by road according to the ARE, for each building",
        key: "Accessibility by road"
      },
      transport_accessibility: {
        key: "Accessibility by public transport",
        description: "Average of the accessibility score by public transport according to the ARE, for each building",
        title: "By train"
      },
      title: "Accessibility"
    },
    accessibility: {
      aged_care: "Aged care",
      computed_public_transport_minute_mean: "Public transport",
      computed_restaurants_meter_mean: "Restaurants",
      computed_pt_accessibility_mean: {
        title: "Average accessibility score"
      },
      computed_early_years_meter_mean: "Early years",
      mean_shops: "Shops",
      transport_train: "Train",
      computed_healthcare_minute_mean: "Health care",
      mean_primary_education: "Primary education",
      tree: {
        title: "Accessibility by means of transportation"
      },
      mean_restaurants: "Restaurants",
      computed_public_open_space_meter_mean: "Public open space",
      computed_healthcare_meter_mean: "Health care",
      computed_cultural_venues_meter_mean: "Cultural venues",
      computed_aged_care_minute_mean: "Aged care",
      early_years: "Early years",
      computed_transport_bus_minute_mean: "Bus",
      computed_secondary_education_meter_mean: "Secondary education",
      computed_aged_care_meter_mean: "Aged care",
      computed_restaurants_minute_mean: "Restaurants",
      mean_score: "Score",
      cultural_venues: "Cultural venues",
      mean_transport_train: "Train",
      computed_transport_train_meter_mean: "Train",
      computed_social_and_cultural_activities_minute_mean: "Social and cultural activities",
      computed_cultural_venues_minute_mean: "Cultural venues",
      mean_cultural_venues: "Cultural venues",
      computed_transport_bus_meter_mean: "Bus",
      computed_sports_recreation_meter_mean: "Sports recreation",
      computed_transport_train_minute_mean: "Train",
      title: "Accessibility",
      computed_public_open_space_minute_mean: "Public open space",
      computed_secondary_education_minute_mean: "Secondary education",
      healthcare: "Health care",
      mean_secondary_education: "Secondary education",
      computed_primary_education_meter_mean: "Primary education",
      computed_sports_recreation_minute_mean: "Sports recreation",
      shops: "Shops",
      computed_transport_bike_meter_mean: "Bike transport",
      computed_primary_education_minute_mean: "Primary education",
      transport_bus: "Bus",
      computed_transport_bike_minute_mean: "Bike transport",
      mean_aged_care: "Aged care",
      computed_shops_meter_mean: "Shops",
      computed_road_accessibility_mean: {
        title: "Average accessibility score"
      },
      table: {
        title: "Average walking travel time to amenities"
      },
      primary_education: "Primary education",
      secondary_education: "Secondary education",
      computed_shops_minute_mean: "Shops",
      mean_early_years: "Early years",
      restaurants: "Restaurants",
      computed_early_years_minute_mean: "Early years",
      computed_aged_and_early_years_care_minute_mean: "Aged and early care",
      score: "Score",
      radar: {
        title: "Accessibility to amenities"
      },
      mean_healthcare: "Health care",
      mean_transport_bus: "Bus"
    },
    well_being: {
      public_utility_density: {
        key: "Share of public utility buildings",
        description: "This measures the share of public utility buildings (hospitals, age care facilities, schools\u2026) in the portfolio of the vehicle",
        title: "Public utility buildings"
      },
      green_density: {
        title: "Greenery",
        key: "Green density",
        description: "Green density contains an average of the share of surrounding hectares containing a majority of green area for each building, according to land use (NOAS04)"
      },
      computed_public_utility_density: {
        title: "Public utility density"
      },
      title: "Well-being",
      computed_green_density: {
        title: "Green density"
      }
    },
    density: {
      title: "Density",
      computed_job_density: {
        title: "Job density"
      },
      computed_population_density: {
        title: "Population density"
      },
      population_density: {
        title: "Population density",
        key: "Population density",
        description: "Population density measures the average population density in surrounding hectares, according to STATPOP, per building"
      },
      job_density: {
        description: "Job density measures the average job density in surrounding hectares, according to STATENT, per building",
        title: "Jobs density",
        key: "Jobs density"
      }
    },
    promiscuity: {
      tile: {
        occupancy: "Occupancy",
        migration: "Migration"
      },
      arrival_per_inhabitant: "Arrival per inhabitant",
      title: "Population density",
      departure_per_inhabitant: "Departure per inhabitant",
      per_bedroom: "Per bedroom",
      per_100_m2: "Per 100 m\xB2"
    },
    demographic: {
      tile: {
        ages: "Ages",
        gender: "Gender",
        foreigners: "Foreigners"
      },
      title: "Demographic"
    },
    tile: {
      accessibility_to_services: "Accessibility to services",
      accessibility_others: "Other (avg. distance)",
      accessibility_transportation: "Public transportation (avg. distance)",
      accessibility_education: "Health and education (avg. distance)",
      accessibility_score: "Accessibility"
    },
    press_score: "Social PRESS score:",
    title: "Social"
  },
  designation: {
    instrument_name: "Name of the instrument",
    currency: "Currency",
    ticker: "Common name",
    isin: "ISIN",
    bloomberg_ticker: "Bloomberg Ticker",
    valor_no: "Valor number"
  },
  financials_per_share: {
    last_distribution: "Last distribution date",
    share_class_nb: "Outstanding shares",
    share_class_gav: "Gross asset value (GAV)",
    share_market_price: "Share price",
    share_class_nav: "Net asset value (NAV)",
    distribution_value: "Distribution value"
  },
  composition: {
    lot_area: "Plot area",
    lots_nb: "Number of plots",
    fund_age: "Age of real estate Portfolio",
    other_area: "Total other area",
    report_date: "Last report",
    buildings_nb: "Number of buildings",
    office_area: "Total office area",
    semi_annual_report_date: "Last report (semi-annual)",
    mixed_area: "Total mixed area",
    building_groups_nb: "Number of building groups",
    residential_area: "Total residential area",
    plot_area: "Total plot area",
    commercial_area: "Total commercial area",
    dwellings_nb: "Number of dwellings",
    report_age: "Age of current real estate report",
    industrial_area: "Total industrial area",
    total_area: "Total area",
    annual_report_date: "Last report (annual)"
  },
  trading: {
    title: "Trading"
  },
  overview: {
    agio: "Agio",
    total_co2: "CO\u2082",
    total_net_assets: "TNA",
    debt_ratio: "Debt ratio",
    esg_rating: "PRESS rating",
    net_initial_yield: "Net initial yield",
    roa: "ROA",
    market_cap: "Market Cap",
    net_rent: "Rental income",
    ter_gav: "TERrefGAV"
  },
  description: {
    ranking: "Fund ranking:",
    tile: {
      buildings: "Buildings",
      allocation_treemap: "Allocation treemap",
      geo_treemap: "Geographic treemap",
      stock: "Stock",
      composition: "Composition",
      administrative: "Administrative",
      designation: "Designation",
      distribution: "Distribution",
      areas: "Areas"
    },
    distribution: {
      value_string: "Area",
      label: {
        reported_type: "Type",
        typology: "Typology",
        region: "Canton",
        type: "Category",
        class: "Class"
      },
      label_string: "Canton"
    },
    allocation: {
      title: "Allocation"
    },
    identification: {
      title: "Identification"
    },
    overview: {
      title: "Overview",
      map: "Map"
    },
    title: "Description",
    composition: {
      title: "Composition"
    }
  },
  stock: {
    distribution_frequency: "Frequency of distribution",
    launch_date: "Launch date",
    units_nb: "Outstanding shares",
    last_distribution: "Last distribution date",
    year_end: "Year-end date",
    units_class: "Class of units",
    distribution_date: "Distribution date"
  },
  accounting: {
    title: "Accounting"
  },
  environment: {
    energy_distribution: {
      value_string: "Heated area",
      label_string: "Heating source"
    }
  },
  transactions: {
    value: {
      sale: "sold",
      purchase: "purchased"
    },
    title: "Transactions"
  },
  debt: {
    title: "Debt"
  },
  report: {
    semi_annual: "Semi Annual Report",
    annual: "Annual Report"
  },
  page: {
    title: "All swiss funds"
  },
  assets: {
    title: "Inventory"
  }
};
var screener = {
  tabs: {
    esg: "ESG",
    accounting: "Accounting",
    information: "Information",
    governance: "Governance",
    trading: "Trading",
    structure: "Structure",
    fees: "Fees",
    financial: "Financial",
    stock: "Stock performance",
    type: "Type",
    saved_screens: "Saved screens",
    energy: "Energy",
    performance: "Performance",
    social: "Social",
    dimension: "Dimension",
    legal_forms: "Legal forms",
    transaction: "Transaction",
    location: "Location",
    screener: "Screener"
  },
  filters: {
    multi_select: {
      options: {
        unlisted_fund: "Unlisted fund",
        mixed: "Mixed",
        commercial: "Commercial",
        foundation: "Foundation",
        real_estate_firm: "Real estate firm",
        listed_fund: "Listed fund",
        residential: "Residential"
      }
    },
    labels: {
      floors_nb: "Floors number",
      idc: "Energy intensity",
      rooms_nb: "Rooms number",
      street: "Street",
      roa: "ROA",
      price: "Price",
      columns_to_ignore: "Columns",
      region: "Region",
      canton: "Canton",
      potential_net_rent_per_m2: "Potential net rent per m\xB2",
      net_rent: "Rental income",
      dwellings_nb: "Number of dwellings",
      plot_surface: "Plot surface",
      floor: "Floor",
      rent: "Rental income",
      construction_year: "Construction year",
      potential_net_rent: "Potential net rent",
      ground_area: "Ground area",
      undefined: "-",
      sort: "Sort",
      buildings_nb: "Buildings number",
      potential_charges: "Potential charges",
      label: "Label",
      municipality: "Municipality",
      co2: "CO\u2082",
      potential_market_value: "Potential market value",
      potential_market_value_per_m2: "Potential market value per m\xB2",
      locality: "Locality",
      area: "Plot surface",
      potential_roa: "ROA",
      charges: "Tenant charges",
      elevator: "Elevator",
      potential_charges_per_m2: "Potential charges per m\xB2",
      energy_source_heating: "Heating source"
    },
    panel: {
      show: "Show"
    },
    groups: {
      information: "Information"
    },
    single_select: {
      options: {
        radar: "Radar",
        area: "Area chart",
        scatter: "Scatter chart",
        boxplot: "Boxplot",
        heatmap: "Heatmap",
        bar: "Bar chart",
        line: "Line chart",
        histogram: "Histogram",
        "1m": "1M",
        "5y": "5Y",
        ytd: "YTD",
        "7d": "7D",
        "2y": "2Y",
        "3m": "3M",
        "6m": "6M",
        "1y": "1Y",
        "3y": "3Y",
        "4y": "4Y",
        false: "False",
        max: "Max",
        true: "True"
      }
    }
  }
};
var actions = {
  request_download: {
    message: "Request created",
    csv: "Download CSV"
  },
  screener: {
    filter: {
      remove: "Remove filter",
      edit: "Edit filter",
      save: "Save filter",
      search: "Filters"
    },
    filter_header: {
      header: "Columns",
      label: "Set visibility of the columns"
    },
    preset: {
      save: "Save screen",
      delete: "Delete screen",
      copy: "Copy screen",
      reset: "Reset screen"
    },
    per_page: {
      header: "Number of rows",
      label: "Rows per page"
    }
  },
  add_to_portfolios: {
    modal: {
      portfolio_name: "Portfolio Name",
      new: "New",
      name: "Name",
      add_to_existing: "Add to existing",
      create_button: "Create"
    },
    confrm_modal: {
      title: "Dwellings already contained",
      buttons: {
        confirm: "Proceed",
        cancel: "Back "
      }
    },
    confirm_modal: {
      text_2: "Do you want to override them with the building instead?",
      text_1: "Portfolio already contains dwelling(s) of {{building_label}}."
    },
    success_add_portfolio: {
      message: "Adding {{asset}} to your {{portfolio_state}} portfolio",
      title: "Successful"
    },
    adding_portfolio: {
      title: "Adding",
      message: "Adding {{asset}}(s) to your portfolio"
    },
    success_create_portfolio: {
      message: "New portfolio has been created",
      title: "Successful"
    },
    title: "Add to portfolio"
  },
  portfolios: {
    remove: {
      success: {
        message: "{{ asset }}(s) removed from your portfolio"
      }
    }
  },
  update: {
    processing: {
      done: "Operation is done successfully. Page will be updated soon.",
      message: "Operation will be done soon.",
      title: "Updating"
    }
  },
  watchlist: {
    remove: {
      button: {
        label: "Unfollow"
      },
      success: {
        message: "Asset removed from your watchlist"
      }
    },
    add: {
      button: {
        label: "Follow"
      },
      success: {
        message: "Asset added to your watchlist"
      }
    }
  },
  companies: {
    delete: "Delete",
    create: "Create company"
  },
  add_to_watchlist: {
    title: "Add to watchlist"
  }
};
var table_header = {
  r_total_cash: "Total cash",
  total_net_assets: "Total net assets",
  reported_total_area: "Rental space",
  r_ebit_margin: "EBIT margin",
  area: "Area",
  c_total_current_agio_compounded: "Total current agio compounded",
  m_dividend_yield: "Current dividend yield",
  buyer_name: "Buyer",
  email: "Email",
  energy_source_heating: "Heating source",
  r_gav_before_distribution: "GAV before distribution",
  cost_price: "Cost price",
  r_nav_before_distribution: "NAV before distribution",
  id: "ID",
  total_consumer_seat: "Total consumer seats",
  three_years_return: "3Y net return",
  r_net_income_available_for_distribution: "Net income available for distribution",
  r_tna_before_distribution: "TNA before distribution",
  r_capital_distribution: "Capital distribution",
  r_total_provisions: "Total provisions",
  m_share_price: "Share price",
  potential_market_value_per_m2: "Market value per m\xB2",
  municipality_nb: "Municipality nb",
  floor: "Floor",
  consumer_users: "Consumer users",
  r_absolute_custodian_bank_fees: "Custodian bank fees",
  r_long_term_liabilities: "Long term liabilities",
  c_pe_ratio: "P/E ratio",
  r_taxes: "Taxes",
  commercial_area: "Commercial area",
  contact_user_email: "Contact user email",
  c_median_maturity: "Median maturity",
  r_commercial_rental_space: "Commercial rental space",
  r_absolute_directors_fees: "Absolute directors fees",
  r_realised_capital_gains_and_losses: "Realised capital gains and losses",
  start: "Start",
  r_ebit: "EBIT",
  region: "Region",
  m_unit_outstanding: "Outstanding units",
  r_net_assets_at_end_of_the_financial_year: "Net assets at end of the financial year",
  hist_volatility_30_days: "1M historical volatility",
  estimated_idc_per_m2: "Energy intensity per m\xB2",
  share_class_nav: "Net Asset Value",
  building_groups_nb: "Number of building groups",
  one_year_avg_volume: "1Y avg volume",
  ewid: "Ewid",
  m_dividend: "Dividend",
  canton: "Canton",
  r_unrealised_capital_gains_and_losses: "Unrealised capital gains and losses",
  share_class_nb: "Shares nb",
  used_all_seats: "Total used seats",
  commercial_spaces_area: "Commercial area",
  fund_names: "Landlord name",
  r_agio_at_year_end: "Agio at year end",
  r_share_buyback_commissions: "Share buyback commissions",
  r_construction_and_works_fees: "Construction and works fees",
  r_other_assets: "Other assets",
  actual_rental_status_target: "Target rental income",
  r_nopat: "NOPAT",
  contact_user: "Contact user",
  already_reimbursed: "Already reimbursed",
  c_nav_compounded: "NAV compounded",
  r_absolute_management_fees: "Management fees",
  sector_nb: "Sector number",
  r_variation_estimated_liquidation_taxes: "Variation estimated liquidation taxes",
  related_am: "Related account manager",
  r_tga_before_distribution: "TGA before distribution",
  investor_users: "Investor users",
  ground_area: "Ground area",
  potential_gross_rent_per_m2: "Gross rent per m\xB2",
  ter_nav: "TERrefNAV",
  value_net_asset: "Net asset value",
  r_invested_capital: "Invested capital",
  real_rent: "Real rent",
  c_current_agio_after_distribution: "Current agio after distribution",
  total_gross_assets: "Total gross asset",
  total_institutional_seat: "Total institutional seats",
  actual_market_value: "Market value",
  c_debt_ratio: "Debt ratio",
  r_total_liabilities: "Total liabilities",
  r_ter_nav: "TERrefNAV",
  r_provisions_for_future_works: "Provisions for future works",
  r_other_revenue: "Other revenue",
  r_tna_after_distribution: "TNA after distribution",
  target_rent: "Target rent",
  r_property_management_expenses: "Property management expenses",
  locality: "Locality",
  co2: "CO\u2082",
  hist_volatility_180_days: "6M historical volatility",
  r_maintenance_costs: "Maintenance costs",
  seller_name: "Seller",
  energy_intensity: "Energy intensity",
  r_total_dividend: "Total dividend",
  potential_net_rent: "Rental income",
  c_total_cash_per_share: "Total cash per share",
  date: "Year",
  potential_charges_monthly: "Monthly tenant charges",
  total_investor_seat: "Total investor seats",
  real_net_rent: "Rental income",
  c_current_liabilities: "Current liabilities",
  r_short_term_liabilities: "Short term liabilities",
  real_roa: "ROA",
  c_tga_compounded: "TGA compounded",
  c_total_current_agio_after_distribution: "Total current agio after distribution",
  qtd_net_return: "QTD net return",
  c_net_initial_yield: "Net initial yield",
  c_current_agio_compounded: "Current agio compounded",
  r_total_revenue: "Total revenue",
  r_other_rental_space: "Other rental space",
  implied_volatility: "Implied volatility",
  c_gav_after_distribution: "GAV after distribution",
  phone: "Phone",
  potential_total_income: "Net rent",
  r_administration_of_buildings: "Administration of buildings",
  duplex: "Duplex",
  r_dividend_from_direct_rental_income: "Dividend from direct rental income",
  last_report_date: "Last report date",
  mtd_net_return: "MTD net return",
  social: "S Score",
  real_charges_monthly: "Monthly tenant charges",
  yearly_management_fee: "Management fee",
  end: "End",
  nb: "Plot number",
  r_mortgage_interest: "Mortgage interest",
  share_class_gav: "Gross assets value",
  street_short: "Address",
  ticker: "Ticker",
  potential_market_value: "Market value",
  one_year_total_return: "1Y total return",
  r_tna: "TNA",
  label: "Label",
  r_absolute_legal_fees: "Absolute legal fees",
  r_net_income: "Net income",
  roic: "ROIC",
  rental_losses: "Rental Losses",
  municipality_name: "Municipality",
  r_administration_expenses: "Administration expenses",
  agio: "Agio",
  license_use: "License use",
  has_building: "Has Building",
  r_dividend_from_capital_gains: "Dividend from capital gains",
  r_absolute_property_management_fees: "Absolute property management fees",
  r_auditing_expenses: "Auditing expenses",
  companies: "Companies",
  last_active: "Last active",
  energy_source_water: "Water heating source",
  construction_date: "Construction year",
  r_commercial_spaces_area: "Commercial area",
  used_consumer_seat: "Used consumer seats",
  r_max_share_buyback_commissions: "Max share buyback commissions",
  r_market_value: "Market value",
  minergie_label: "Label",
  rent_default_rate: "Rent default",
  rate: "Rate",
  three_months_avg_volume: "3M avg volume",
  r_profit_and_capital_taxes: "Profit and capital taxes",
  actual_rental_status_real: "Rental income",
  r_roi: "ROI",
  r_dividend_from_indirect_rental_income: "Dividend from indirect rental income",
  ytd_net_return: "YTD net return",
  r_ter_mv: "TERrefMV",
  r2: "R\xB2",
  dwellings_nb: "Number of dwellings",
  r_cost_price: "Cost price",
  r_performance: "Performance",
  fifty_two_weeks_high: "52W high",
  actual_target_roa: "Target ROA",
  currency: "Currency",
  r_max_custodian_bank_fees: "Max custodian bank fees",
  r_long_term_interest_bearing_mortgages: "Long term mortgages bearing interest",
  labels: "Minergie Labels",
  beta: "Beta",
  payout_ratio: "Payout ratio",
  developer_mode: "Developer mode",
  fifty_two_weeks_low: "52W low",
  high: "High",
  social_rating: "S rating",
  c_roa: "ROA",
  c_weighted_average_cost_of_debt: "Weighted average cost of debt",
  r_debt_ratio: "Debt ratio",
  r_unrealised_gains_and_losses_including_var_est_liq_tax: "Unrealised gains/losses including liquidation tax variation",
  contact_user_phone: "Contact user phone number",
  zip: "Zip",
  dividend_date: "Dividend date",
  r_residential_area: "Residential area",
  r_purchase_and_sale_fees: "Purchase and sale fee",
  roe: "ROE",
  low: "Low",
  r_total_income: "Total income",
  rights: "Rights",
  r_roe: "ROE",
  c_ebit_margin: "EBIT margin",
  r_absolute_custodian_bank_commission_fees: "Absolute custodian bank commission fees",
  r_other_administration_expenses: "Other administration expenses",
  r_share_issue_commissions: "Share issue commissions",
  hist_volatility_250_days: "1Y historical volatility",
  six_months_return: "6M net return",
  r_wault: "WAULT",
  r_total_net_assets: "Total net assets",
  r_maintenance_and_repairs_expenses: "Maintenance and repairs expenses",
  r_other_short_term_liabilities: "Other short term liabilities",
  lots_nb: "Number of plots",
  r_custodian_bank_fees: "Custodian bank fees",
  r_gross_yield: "ROA",
  r_net_assets_at_beginning_of_the_financial_year: "Net assets at beginning of the financial year",
  c_earnings_per_share: "Earnings per share",
  c_median_cost_of_debt: "Median cost of debt",
  esg: "ESG Score",
  last_activity_date: "Last active",
  potential_charges_per_m2: "Charges per m\xB2",
  five_days_avg_volume: "5D avg volume",
  volume: "Volume",
  five_years_avg_dividend_yield: "5Y avg dividend yield",
  r_units_outstanding: "Units outstanding",
  r_negative_interest: "Negative interest",
  environmental_rating: "E rating",
  c_gav_compounded: "GAV compounded",
  one_month_return: "1M net return",
  total_area: "Total area",
  r_total_interest: "Total interest",
  dividend_yield: "Dividend yield",
  institutional_users: "Institutional users",
  r_total_area: "Total area",
  egid: "EGID",
  c_price_to_book_value: "Price to book value",
  r_net_assets_before_estimated_liquidation_taxes: "Net assets before estimated liquidation taxes",
  r_retained_earnings: "Retained earnings",
  three_months_return: "3M net return",
  value_gross_asset: "Gross asset value",
  m_share_price_var: "Share price variation",
  last_renovation_year: "Last renovation year",
  subscribed_date: "Subscribed since",
  r_rental_losses: "Rental losses",
  m_market_cap: "Market Cap",
  r_total_properties: "Total properties",
  free_investor_seat: "Left investor seats",
  r_dividend_yield: "Dividend yield at year end",
  r_property_management_fees: "Property management fees",
  short_name: "Short Name",
  market_value: "Market value",
  bloomberg_ticker: "Ticker",
  rent_defaults: "Rent defaults",
  r_short_term_interest_bearing_mortgages: "Short term mortgages bearing interest",
  free_institutional_seat: "Left institutional seats",
  estimated_co2_emission_per_m2: "CO\u2082 per m\xB2",
  r_capital_employed: "Capital employed",
  alpha: "Alpha",
  actual_real_roa: "ROA",
  debt_ratio: "Debt ratio",
  enterprise: "Enterprise",
  net_initial_yield: "Net initial yield",
  launch_date: "Launch date",
  fund_legal_forms: "Type of landlord",
  c_weighted_average_maturity: "Weighted average maturity",
  esg_rating: "ESG rating",
  counterpart_fund: "Counterpart fund",
  r_roce: "ROCE",
  residential_area: "Residential area",
  five_years_total_return: "5Y total return",
  potential_net_rent_per_m2: "Rental income per m\xB2",
  environmental: "E Score",
  dividend: "Dividend",
  days_left: "Days left",
  rental_space: "Area",
  r_revenue_from_postal_and_bank_accounts: "Revenue from postal and bank accounts",
  r_tga: "TGA",
  roi: "ROI",
  one_month_avg_volume: "1M avg volume",
  roa: "ROA",
  r_market_maker_fees: "Market maker fees",
  r_realised_income: "Realised income",
  r_ordinary_maintenance_and_repairs_expenses: "Ordinary maintenance and repairs expenses",
  r_roic: "ROIC",
  r_roa: "ROA",
  rooms_nb: "Number of rooms",
  hist_volatility_90_days: "3M historical volatility",
  six_months_avg_volume: "6M avg volume",
  c_revenue_per_share: "Revenue per share",
  c_payout_ratio: "Payout ratio",
  address: "Address",
  subscription_start: "Subscription date",
  c_roce: "ROCE",
  r_absolute_custodian_bank_distribution_fees: "Absolute custodian bank distribution fees",
  turnover: "Turnover",
  net_rent: "Net rent",
  value: "Value",
  potential_charges: "Tenant charges",
  r_tga_after_distribution: "TGA after distribution",
  all_users: "Team members",
  r_payout_ratio: "Payout ratio",
  role: "Role",
  ter_gav: "TERrefGAV",
  solar_existing: "Installed solar power",
  r_max_management_fees: "Max management fees",
  potential_gross_rent: "Gross rent",
  rate_type: "Rate type",
  r_building_expenses: "Building expenses",
  expires_at: "Expiration date",
  r_residential_rental_space: "Residential rental space",
  c_total_agio_at_year_end: "Total agio at year end",
  r_property_tax: "Property tax",
  r_valuation_and_auditing_expenses: "Valuation and auditing expenses",
  r_estimated_liquidation_taxes: "Estimated liquidation taxes",
  isin: "ISIN",
  r_max_share_issue_commissions: "Max share issue commissions",
  real_market_value: "Market value",
  c_agio_at_year_end: "Agio at year end",
  state: "Invitation process",
  vwap: "VWAP",
  governance: "G Score",
  c_operating_profit: "Operating profit",
  r_mixed_rental_space: "Mixed rental space",
  r_market_cap: "Market cap at year end",
  r_max_property_management_fees: "Max property management fees",
  r_real_rent: "Rental income",
  building_category: "Building category",
  c_three_years_total_return: "3Y total return",
  real_charges: "Tenant charges",
  fund_name: "Fund name",
  r_ter_gav: "TERrefGAV",
  c_nav_after_distribution: "NAV after distribution",
  environment: {
    score: "Environment score"
  },
  r_other_expenses: "Other expenses",
  c_loan_to_value: "Loan to value",
  r_share_price: "Share price",
  free_consumer_seat: "Left consumer seats",
  r_other_long_term_liabilities: "Other long term liabilities",
  total_co2: "CO\u2082 emissions",
  buildings_nb: "Number of buildings",
  r_extraordinary_maintenance_and_repairs_expenses: "Extraordinary maintenance and repairs expenses",
  r_max_construction_and_works_fees: "Max construction and works fees",
  type: "Type",
  user: "User",
  total_all_seats: "Total seats",
  r_target_rent: "Target rental income",
  r_rental_income: "Rental income",
  egrid: "EGRID",
  r_rental_space: "Rental space",
  used_institutional_seat: "Used institutional seats",
  governance_rating: "G rating",
  r_provisions_for_doubtful_debtors: "Provisions for doubtful debtors",
  r_management_fees: "Management fees",
  potential_roa: "ROA",
  c_five_years_total_return: "5Y total return",
  ter_mv: "TERrefMV",
  r_valuation_expenses: "Valuation expenses",
  three_years_total_return: "3Y total return",
  legal_form: "Legal form",
  five_years_return: "5Y net return",
  last: "Last",
  name: "Name",
  c_tna_compounded: "TNA compounded",
  r_other_interest: "Other interest",
  r_total_expenses: "Total expenses",
  created_at: "Creation date",
  market_cap: "Market capitalisation",
  r_ordinary_income_carried_forward_from_previous_financial_year: "Ordinary income carried forward from previous financial year",
  open: "Open",
  key_name: "Key name",
  real_net_rent_monthly: "Monthly rental income",
  c_current_ratio: "Current ratio",
  c_roe: "ROE",
  r_plots_rental_space: "Plots rental space",
  floors_nb: "Number of floors",
  r_max_purchase_and_sale_fees: "Max purchas and sale fees",
  r_interest_on_building_rights: "Interest on building rights",
  m_dividend_date: "Dividend date",
  entity_name: "Name",
  lot_nb: "Plot number",
  used_investor_seat: "Used investor seats",
  actions: "More actions",
  potential_net_rent_monthly: "Monthly rental income",
  market_price: "Share price",
  expiration_date: "Contract end date",
  estimated_area: "Area",
  one_year_return: "1Y net return",
  r_total_rental_space: "Total rental space",
  r_dividend_distribution: "Dividend distribution",
  building_class: "Building class",
  tx_price: "Transaction price",
  construction_year: "Construction year",
  tx_year: "Transaction year",
  reported_energy_intensity: "Energy intensity",
  reported_total_energy: "Total energy",
  estimated_total_market_value: "Total market value",
  reported_share_fossil: "Share of fossil Fuel ",
  reported_heated_area: "Heated area",
  reported_co2_per_m2: "CO\u2082 per  m\xB2",
  reported_coverage_share_fossil: "Coverage rate",
  computed_energy_source_heating_type_coverage: "Coverage",
  reported_co2: "Total CO\u2082",
  owner_types: "Owner types",
  owner_names: "Owner names"
};
var highlight = {
  label: {
    category: {
      high: "High",
      very_high: "Very high",
      medium: "Medium",
      low: "Low",
      very_low: "Very low",
      null: "-",
      undefined: "-"
    }
  }
};
var asset_page = {
  environmental: {
    energy: {
      co2: {
        title: "CO\u2082 emissions",
        total_official_co2_emission: "Total CO\u2082 (official)",
        total_estimated_co2_emission: "Total CO\u2082",
        estimated_co2_emission_per_m2: "CO\u2082 per m\xB2",
        official_co2_emission_per_m2: "CO\u2082 per m\xB2 (official)",
        estimated_co2: "CO\u2082 emissions "
      },
      idc: {
        estimated_idc: "Energy intensity",
        total_estimated_idc: "Total Energy intensity",
        title: "Energy intensity",
        total_official_idc: "Total Energy intensity (official)",
        official_idc_per_m2: "Energy intensity per m\xB2 (official)",
        estimated_idc_per_m2: "Energy intensity per m\xB2"
      },
      heating: {
        energy_generator_heating_1: "Heating generator",
        energy_source_heating_1: "Heating energy source",
        energy_generator_water_1: "Hot water generator",
        energy_source_water_1: "Hot water energy source",
        title: "Heating generation"
      },
      title: "Energy",
      solar: {
        solar_existing: "Installed solar power",
        title: "Solar",
        solar_potential: "Solar potential"
      }
    },
    risk: {
      climate_risk_index: {
        title: "Climate risk index"
      },
      sia261: "Seismic zone SIA 261",
      debris_flow: "Debris flow",
      overbank_sedimentation: "Overbank sedimentation",
      risk: {
        title: "Environmental risks"
      },
      chart: {
        suffix: "/10",
        description: "The climate risk index is calculated based on the exposure to different environmental risks. Each risk has an equal weight in the index."
      },
      avalanches: "Avalanches",
      hail_hazard_10_years_average: "Hail size",
      title: "Risks",
      rockfalls: "Rockfalls",
      floods_50_years: "Floods",
      landslides: "Landslides",
      windstorm_avg_rate: {
        label: "Windstorm"
      },
      hail_avg_rate: {
        label: "Hail"
      },
      damage_rate: {
        title: "Damage rate"
      },
      detailed_rates: {
        title: "Detailed rates"
      },
      flood_avg_rate: {
        label: "Flood"
      }
    },
    environment: {
      pollution: {
        road_noise_day: {
          label: "Day traffic noise"
        },
        road_noise_night: {
          label: "Night traffic noise"
        },
        rail_noise_night: {
          label: "Night train noise"
        },
        rail_noise_day: {
          label: "Day train noise"
        },
        title: "Noise pollution"
      },
      climate: {
        temperature: {
          title: "Average temperature"
        },
        title: "Climate",
        rain: {
          title: "Average rainfall"
        },
        sunlight: {
          title: "Average sunlight"
        }
      },
      title: "Environment"
    },
    co2: {
      co2_scope_1_2_33_per_m2: "CO\u2082 (scope 1 + 2 + 3.3)",
      co2_scope_2_per_m2: "CO\u2082 (scope 2)",
      co2_scope_1_2_per_m2: {
        description: "CO\u2082 emissions are computed using the energy intensity multiplied by the REIDA coefficient for each building.",
        key: "CO\u2082 (scope 1 + 2)"
      },
      co2_scope_1_per_m2: "CO\u2082 (scope 1)",
      total_co2_scope_1_2: "Total CO\u2082 (scope 1 + 2)",
      total_co2_scope_1_2_33: "Total CO\u2082 (scope 1 + 2 + 3.3)",
      co2_scope_33_per_m2: "CO\u2082 (scope 3.3)"
    },
    idc: {
      idc_per_m2: {
        description: "Energy intensity measures the estimated energy consumption per square meter of heating surface over one year the building.",
        key: "Energy intensity"
      },
      total_idc: "Total energy"
    },
    title: "Environmental",
    risks: {
      damage_rate: {
        key: "Total per 1\u2019000 expected annual damage",
        description: "Expected average damage caused every year to the building by hail, flood and windstorm combined, per 1'000 CHF"
      }
    }
  },
  social: {
    demographic: {
      birth: {
        subject: "Births"
      },
      civil_status: {
        death: "Death p.a.",
        divorce: "Divorce p.a.",
        birth: "Births p.a.",
        title: "Civil status",
        household: "Mean household size",
        marriage: "Marriage p.a."
      },
      ages: {
        title: "Ages"
      },
      emigration: {
        subject: "Emigration"
      },
      title: "Demographic",
      vital_statistics: {
        title: "Vital statistics"
      },
      immigration: {
        subject: "Immigration"
      },
      foreigners: {
        title: "Foreigners"
      },
      gender: {
        title: "Gender"
      },
      migration: {
        title: "Migration"
      },
      death: {
        subject: "Deaths"
      }
    },
    transportation_accessibility: {
      computed_early_years_meter: "Early years",
      computed_shops_minute: "Shops",
      computed_primary_education_meter: "Primary education",
      computed_cultural_venues_meter: "Cultural venues",
      computed_restaurants_meter: "Restaurants",
      radar: {
        title: "Accessibility to amenities"
      },
      computed_sports_recreation_minute: "Sports recreation",
      computed_transport_bike_minute: "Bike transport",
      computed_sports_recreation_meter: "Sports recreation",
      computed_restaurants_minute: "Restaurants",
      official_pt_accessibility: {
        title: "Average accessibility score"
      },
      computed_healthcare_meter: "Health care",
      computed_social_and_cultural_activities_minute: "Social and cultural activities",
      computed_public_open_space_minute: "Public open space",
      computed_cultural_venues_minute: "Cultural venues",
      computed_public_transport_minute: "Public transport",
      computed_transport_bus_meter: "Bus",
      road_accessibility: {
        label: "Accessibility by road",
        title: "By road",
        description: "Accessibility score by road according to the ARE"
      },
      transport_accessibility: {
        title: "By train",
        label: "Accessibility by public transport",
        description: "Accessibility score by public transport according to the ARE"
      },
      computed_aged_care_minute: "Aged care",
      title: "Accessibility",
      computed_aged_care_meter: "Aged care",
      computed_transport_bus_minute: "Bus",
      computed_healthcare_minute: "Health care",
      official_road_accessibility: {
        title: "Average accessibility score"
      },
      computed_secondary_education_meter: "Secondary education",
      computed_shops_meter: "Shops",
      computed_transport_bike_meter: "Bike transport",
      computed_aged_and_early_years_care_minute: "Aged and early care",
      computed_early_years_minute: "Early years",
      computed_transport_train_meter: "Train",
      computed_primary_education_minute: "Primary education",
      map: {
        title: "Amenities map"
      },
      computed_transport_train_minute: "Train",
      table: {
        title: "Average walking travel time to amenities"
      },
      computed_secondary_education_minute: "Secondary education",
      computed_public_open_space_meter: "Public open space"
    },
    well_being: {
      title: "Well-being",
      public_utility: {
        key: "Public utility building",
        title: "Public utility building"
      }
    },
    accessibility: {
      transportation: {
        title: "Public transportation"
      },
      transport_train: "Train",
      aged_care: "Aged care",
      goods_and_services: {
        title: "Other"
      },
      title: "Distances to goods and services",
      early_years: "Early years",
      distance: {
        title: "Accessibility"
      },
      chart: {
        subject: "Index",
        title: "Accessibility",
        suffix: "/10"
      },
      restaurants: "Restaurants",
      healthcare: "Healthcare",
      shops: "Shops",
      health_and_edu: {
        title: "Health & Education"
      },
      cultural_venues: "Cultural venues",
      primary_education: "Primary education",
      transport_bus: "Bus",
      secondary_education: "Secondary education"
    },
    income_and_taxes: {
      income: {
        label: "Income",
        description: "Description",
        title: "Income",
        subject: "Income per taxpayer"
      },
      wealth: {
        label: "Wealth"
      },
      title: "Income and taxes",
      canton_tax: {
        title: "Canton tax multipliers"
      },
      capital: {
        label: "Capital"
      },
      municipality_tax: {
        title: "Municipality tax multipliers"
      },
      profit: {
        label: "Profit"
      }
    },
    density: {
      occupancy_per_100_m2: {
        title: "Occupancy per 100 m\xB2"
      },
      occupancy: {
        per_meter: "Per 100 m\xB2",
        per_bedroom: "Per bedroom",
        title: "Occupancy"
      },
      migration: {
        departure: "Departure per inhabitant",
        title: "Migration",
        arrival: "Arrival per inhabitant"
      },
      title: "Density",
      green_density: {
        key: "Green density",
        description: "Green density measure the share of surrounding hectares containing a majority of green area, according to land use (NOAS04)",
        title: "Greenery"
      },
      population_density: {
        title: "Population density",
        description: "Population density measures the average population density in surrounding hectares, according to STATPOP, per building",
        key: "Population density"
      },
      job_density: {
        title: "Jobs density",
        description: "Job density measures the average job density in surrounding hectares, according to STATENT, per building",
        key: "Jobs density"
      },
      occupancy_per_m2: {
        subject: "Inhabitants"
      },
      income: {
        title: "Income per taxpayer",
        subject: "Income per taxpayer"
      },
      occupancy_per_bedroom: {
        subject: "Inhabitants",
        title: "Occupancy per bedroom"
      }
    },
    title: "Social"
  },
  valuation: {
    parameters: {
      transaction_fees: {
        property_transfert_fees: {
          suffix: "%",
          label: "Property transfert fees"
        },
        notary_fees: {
          suffix: "%",
          label: "Notary fees"
        },
        land_registration_fees: {
          suffix: "%",
          label: "Land registration fees"
        },
        title: "Transaction fees"
      },
      buyer_seller: {
        other_fees_pts: {
          label: "Other fees",
          suffix: "%"
        },
        title: "Buyer / Seller",
        other_fees_chf: {
          label: "Other fees",
          suffix: "CHF"
        },
        share_buyers_seller: {
          suffix: "%",
          label: "Share buyer / seller"
        },
        asset_manager_fees: {
          suffix: "%",
          label: "Asset manager fees"
        }
      },
      due_diligence_cost: {
        other_valuations: {
          label: "Other valuations",
          suffix: "CHF"
        },
        title: "Due diligence cost",
        valuation: {
          suffix: "CHF",
          label: "Valuation"
        }
      },
      title: "Parameters"
    },
    qh_method: {
      result: {
        title: "Result",
        total_acquisition_cost: {
          suffix: "CHF",
          label: "Total acquisition cost"
        },
        purchase_price: {
          label: "Purchase price",
          suffix: "CHF"
        }
      },
      description: {
        content: "Quanthome's machine learning algorithms estimate the expected target return for the building and predict a value based on the estimated cash flows.",
        title: "Description"
      },
      title: "Quanthome's method"
    },
    cap_rate_method: {
      cap_rate_inputs: {
        title: "Cap rate inputs",
        capitalization_rate: {
          label: "Capitalization rate",
          suffix: "%"
        }
      },
      income_inputs: {
        other: {
          label: "Other income",
          suffix: "CHF"
        },
        dwelling_net_rent: {
          suffix: "CHF",
          label: "Dwelling net rent"
        },
        office_net_income: {
          label: "Office net income",
          suffix: "CHF"
        },
        residential_net_income: {
          suffix: "CHF",
          label: "Residential net income"
        },
        title: "Income inputs",
        industrial: {
          label: "Industrial",
          suffix: "CHF"
        },
        parking: {
          suffix: "CHF",
          label: "Parking"
        },
        commercial: {
          label: "Commercial income",
          suffix: "CHF"
        }
      },
      result: {
        total_acquisition_cost: {
          label: "Total acquisition cost",
          suffix: "CHF"
        },
        purchase_price: {
          suffix: "CHF",
          label: "Purchase price"
        },
        title: "Result"
      },
      description: {
        content: "The capitalization rate (cap rate) method applied to real estate is used to estimate a property's potential value. It is calculated as rental income divided by the target return. Cap rates don't account for future value appreciation or financing costs.",
        title: "Description"
      },
      title: "Cap rate method"
    },
    title: "Valuation"
  },
  description: {
    tile: {
      description: "Description",
      parent_description: "Parent Description",
      usage: "Usage",
      administrative_information: "Administrative Information",
      geometry: "Geometry",
      addresses: "Addresses",
      location: "Location",
      amenities: "Amenities",
      dwellings: {
        parent_description: "Building parent description"
      },
      buildings: {
        parent_description: "Lot description"
      }
    },
    title: "Description",
    identification: {
      title: "Identification"
    },
    general_information: {
      title: "General Information"
    }
  },
  financials: {
    ratio_metric: {
      total_tenant_charges: "Total tenant charges",
      price_per_m2: "Price per m\xB2",
      office: "Office",
      residential: "Residential",
      title: "Metrics per square meter",
      price: {
        title: "Price"
      },
      commercial_spaces: {
        label: "Commercial spaces"
      },
      charges_per_m2: "Tenant charges per m\xB2",
      charges: {
        title: "Charges"
      },
      average: "Average",
      market_value_reported: "Market value",
      rent_per_m2: "Rental income per m\xB2",
      industrial: "Industrial",
      rent: {
        title: "Rental income"
      },
      commercial: "Commercial",
      dwellings: {
        label: "Dwellings"
      },
      market_value: "Market value"
    },
    title: "Financials",
    unit: {
      chf: "CHF"
    },
    charges: {
      title: "Tenant charges"
    },
    tile: {
      charges: "Tenant charges",
      rental_income: "Rental income",
      evolution: "Evolution"
    },
    dwellings: {
      label: "Dwellings"
    },
    revenue: {
      title: "Revenue"
    },
    comparables: {
      title: "Comparables"
    },
    units: {
      total_rent: "CHF",
      commercial_rent: "CHF",
      residential_rent: "CHF"
    },
    performance: {
      rental_income: "Rental income",
      title: "Performance"
    },
    metrics: {
      title: "Metrics per square meter"
    },
    total: {
      label: "Total"
    },
    commercial_spaces: {
      label: "Commercial spaces"
    }
  },
  overview: {
    description: {
      market_value: "Market Value",
      co2: "CO\u2082",
      net_rent: "Rental income",
      idc: "Energy intensity",
      charges: "Tenant charges",
      roa: "ROA"
    }
  },
  governance: {
    item: {
      management: {
        website: "Website",
        name: "Name"
      },
      ownership: {
        link: "link",
        owner: "Owner",
        registry: "Land registry"
      },
      certification: {
        minergy: "Minergie"
      }
    },
    tile: {
      ownership: "Ownership",
      management: "Property management",
      certification: "Certification"
    },
    title: "Governance",
    organisation: {
      title: "Organisation"
    }
  },
  assets: {
    title: "Inventory"
  }
};
var modal = {
  leaving: {
    buttons: {
      proceed: "Proceed"
    },
    default_text: "You have clicked on a link provided by Quanthome SA that will direct you outside of the app. We are not related to this website and or its owner. We highly recommend, for any cases while browsing the web, to never give your personal information without carefully reviewing if the website is (still) a trustworthy one. No website should ask you for your Quanthome credentials nor will any AM ask for your password.",
    registry: {
      title: "Steps to follow in the external process"
    },
    title: "You're about to leave the app"
  },
  notifications: {
    title_emailinfo: "You can now set email preferences",
    administration_linked: "You can now manage enterprise {{enterprise}}.",
    empty_message: "No notifications",
    title_download: "Download",
    subtitle_emailinfo: "manage the emails you will recieve from us",
    administration_days_left: "The state of enterprise {{enterprise}} needs your attention: {{currentState}} state has {{daysLeft}} days left.",
    title: "Notifications",
    title_recoverycode: "Re-generate your recovery codes now",
    administration_examination: "Enterprise {{enterprise}} has been in examination state for one month.",
    title_administration: "Administration",
    administration_unlinked: "Enterprise {{enterprise}} has been removed from your management list."
  },
  downloads: {
    subtitle: {
      file_ready: "Your file is ready to be downloaded",
      file_failed: "Your file has failed due to an error - Please contact your administrator.",
      file_about_to_expire: "Your file is about to expire soon",
      file_expired: "Your file has expired",
      file_be_ready_soon: "Your file will be ready to be downloaded soon"
    },
    empty_message: "No downloads",
    title: "Downloads",
    not_available: "The download feature isn\u2019t available with your current pricing plan."
  },
  preset: {
    title: "Presets",
    empty_message: "No presets"
  },
  support: {
    error_message: {
      bad_category: "You need to select a category",
      too_many_char: "Too many characters {{char_nb}} > 500",
      no_message: "You need to write a message"
    },
    message: "Message",
    select: {
      title: "Problem, message, need, idea...",
      message: "Message",
      need: "Need",
      placeholder: "Choose",
      problem: "Problem"
    },
    success: {
      message: "Your report has been successfully send to our client service",
      title: "Report send"
    },
    title: "Help",
    complete_title: "Support / Contact",
    submit_button: "Ask our support",
    upload: "Upload"
  },
  historic: {
    title: "History"
  },
  history: {
    title: "History",
    empty_history: "No history"
  },
  notification: {
    title_download: "Download"
  }
};
var income_statement = {
  label: {
    total_revenues: "Total revenues",
    r_revenue_from_postal_and_bank_accounts: "Revenue from postal and bank accounts",
    r_building_expenses: "Building expenses",
    interest_expenses: "Interest expenses",
    r_provisions_for_doubtful_debtors: "Provisions for doubtful debtors",
    r_profit_and_capital_taxes: "Profit and capital taxes",
    r_valuation_and_auditing_expenses: "Valuation and auditing expenses",
    r_mortgage_interest: "Mortgage interest",
    r_net_income: "Net income",
    r_market_maker_fees: "Market maker fees",
    r_extraordinary_maintenance_and_repairs_expenses: "Extraordinary maintenance and repairs expenses",
    ordinary_income_carried_forward: "Ordinary income carried forward",
    r_absolute_management_fees: "Absolute management fees",
    retained_earnings: "Retained earnings",
    r_absolute_custodian_bank_distribution_fees: "Absolute custodian bank distribution fees",
    r_maintenance_costs: "Maintenance costs",
    unrealised_gains_losses_including_liquidation_taxes_variation: "Unrealised gains/losses including liquidation taxes variation",
    total_net_income_available_for_distribution: "Total net income available for distribution",
    r_realised_capital_gains_and_losses: "Realised capital gains and losses",
    realised_gains_losses: "Realised gains/losses",
    r_total_interest: "Total interest",
    r_administration_expenses: "Administration expenses",
    r_valuation_expenses: "Valuation expenses",
    other_revenue: "Other revenue",
    capital_distribution: "Capital distribution",
    r_ordinary_income_carried_forward_from_previous_financial_year: "Ordinary income carried forward from previous financial year",
    valuation_and_auditing_expenses: "Valuation and auditing expenses",
    total_income: "Total income",
    r_absolute_directors_fees: "Absolute directors fees",
    r_total_provisions: "Total provisions",
    r_absolute_legal_fees: "Absolute legal fee",
    r_maintenance_and_repairs_expenses: "Maintenance and repairs expenses",
    r_provisions_for_future_work: "Provisions for future work",
    r_dividend_distribution: "Dividend distribution",
    r_net_income_available_for_distribution: "Net income available for distribution",
    r_provisions_for_future_works: "Provisions for future works",
    reproted_market_maker_fees: "Market maker fees",
    r_absolute_custodian_bank_commission_fees: "Absolute custodian bank commission fees",
    r_auditing_expenses: "Auditing expenses",
    dividend_distribution: "Dividend distribution",
    taxes: "Taxes",
    r_unrealised_gains_and_losses_including_var_est_liq_tax: "Unrealised gains/losses including liquidation taxes variation",
    r_interest_on_building_rights: "Interest on building rights",
    r_taxes: "Taxes",
    r_other_interest: "Other interest",
    r_other_administration_expenses: "Other administration expenses",
    r_other_expenses: "Other expenses",
    other_expenses: "Other expenses",
    negative_interest: "Negative interest",
    realised_income: "Realised income",
    maintenance_costs: "Maintenance costs",
    r_unrealised_capital_gains_and_losses: "Unrealised capital gains and losses",
    r_total_expenses: "Total expenses",
    r_total_revenue: "Total revenue",
    reproted_ordinary_maintenance_and_repairs_expenses: "Ordinary maintenance and repairs expenses",
    r_negative_interest: "Negative interest",
    r_total_income: "Total income",
    r_retained_earnings: "Retained earnings",
    r_absolute_custodian_bank_fees: "Absolute custodian bank fees",
    revenue_from_postal_and_bank_accounts: "Revenue from postal and bank accounts",
    year: "Year",
    r_absolute_property_management_fees: "Absolute property management fees",
    r_capital_distribution: "Capital distribution",
    r_administration_of_buildings: "Administration of buildings",
    net_income: "Net income",
    r_ordinary_maintenance_and_repairs_expenses: "Ordinary maintenance and repairs expenses",
    rental_income: "Rental income",
    r_rental_income: "Rental income",
    other_net_income_available_for_distribution: "Other net income available for distribution",
    r_property_management_expenses: "Property management expenses",
    r_other_revenue: "Other revenue",
    r_property_tax: "Property tax",
    r_realised_income: "Realised income",
    total_expenses: "Total expenses"
  },
  unit: {
    chf: "CHF"
  },
  legend: {
    group: {
      income_statement: "Income statement",
      distribution_of_realised_income: "Distribution of realised income"
    }
  }
};
var balance_sheet = {
  label: {
    r_total_cash: "Total cash",
    r_other_assets: "Other assets",
    r_short_term_liabilities: "Short term liabilities",
    r_other_long_term_liabilities: "Other long term liabilities",
    r_total_liabilities: "Total liabilities",
    date: "Date",
    r_short_term_interest_bearing_mortgages: "Short term interest bearing mortgages",
    r_total_net_assets: "Total net assets",
    r_long_term_liabilities: "Long term liabilities",
    r_total_properties: "Total properties",
    total_asset: "Total asset",
    r_tga_before_distribution: "Total assets",
    asset_total: "Total assets",
    r_net_assets_before_estimated_liquidation_taxes: "Net assets before estimated liquidation taxes",
    other_liabilities: "Other liabilities",
    r_tna_before_distribution: "TNA before distribution",
    r_estimated_liquidation_taxes: "Estimated liquidation taxes",
    r_other_short_term_liabilities: "Other short term liabilities",
    total_liabilities: "Total liabilities",
    r_long_term_interest_bearing_mortgages: "Long term interest bearing mortgages"
  },
  legend: {
    group: {
      asset: "Asset",
      liabilities: "Liabilities",
      equity: "Equity"
    }
  },
  unit: {
    chf: "CHF"
  }
};
var portfolios = {
  designation: {
    fund_age: "Age of real estate Portfolio",
    residential_area: "Total residential area",
    total_area: "Total area",
    created_at: "Creation date",
    buildings_nb: "Number of buildings",
    individual_dwellings_nb: "Number of individual dwellings",
    type: "Asset composition of Portfolio",
    industrial_area: "Total industrial area",
    office_area: "Total office area",
    dwellings_nb: "Number of dwellings",
    updated_at: "Last update",
    name: "Name of the instrument",
    commercial_area: "Total commercial area"
  },
  notification: {
    success_create: {
      message: "The portfolio has been successfully created",
      title: "Successfully created"
    }
  },
  environmental: {
    solar_potential: "Total solar potential",
    solar_existing_per_m2: "Installed solar power per m\xB2",
    debris_flow: "Debris flow",
    solar_existing: "Installed solar power",
    floods_50_years: "Floods",
    evolution: {
      chart: {
        title: "Chart"
      }
    },
    avalanches: "Avalanches",
    rockfalls: "Rockfalls",
    estimated_co2_emission_per_m2: "CO\u2082 per m\xB2",
    landslides: "Landslides",
    building_with_solar_existing: "Buildings with solar panels",
    overbank_sedimentation: "Overbank sedimentation",
    hail_hazard_10_years_average: "Hail size",
    total_estimated_co2_emission: "Total CO\u2082",
    estimated_idc_per_m2: "Energy intensity per m\xB2",
    total_estimated_idc: "Total Energy intensity"
  },
  description: {
    distribution: {
      label_string: "Canton",
      value_string: "Area"
    }
  },
  tiles: {
    energy_source: {
      title: "Energy source"
    },
    risks: {
      title: "Environmental risks"
    },
    designation: {
      title: "Designation"
    },
    solar: {
      title: "Solar"
    },
    distribution: {
      title: "Distribution"
    },
    risk_index: {
      title: "Climate risk index"
    },
    idc_and_co2: {
      title: "Energy intensity & CO\u2082"
    },
    composition: {
      title: "Composition"
    }
  },
  environment: {
    energy_distribution: {
      label_string: "Heating source",
      value_string: "Heated area"
    }
  },
  financials: {
    evolution: {
      title: "Evolution",
      chart: {
        title: "Chart"
      }
    },
    performance: {
      title: "Performance",
      evolution: {
        title: "Evolution"
      }
    }
  },
  noright: {
    details: "The portfolio module allows you to have global vision on a real estate portfolio, from financial to ESG data.",
    title: "Portfolios",
    button: "Contact account manager",
    subtitle: "This feature requires a more complete plan."
  },
  widget: {
    identification: {
      title: "Identification"
    },
    risk: {
      title: "Risk"
    },
    energy: {
      title: "Energy"
    }
  },
  overview: {
    type: {
      dwelling: "Dwelling",
      mixed: "Mixed",
      empty: "Empty",
      building: "Building"
    },
    potential_market_value: "Market value",
    potential_roa: "ROA",
    potential_charges: "Charges",
    potential_net_rent: "Rental income"
  },
  modal: {
    confirm_delete: {
      title: "Delete portfolio",
      text: "Are you sure you want to delete this portfolio?",
      cancel: "Back",
      proceed: "Proceed",
      notification: {
        text: "Portfolio has been deleted"
      }
    }
  },
  create_modal: {
    title: "New portfolio"
  }
};
var asset = {
  description: {
    amenities: {
      buildings: {
        imputed_cachet: "Cachet",
        fallout_shelter: "Fallout shelter",
        imputed_elevator: "Elevator",
        imputed_near_highway: "Near highway",
        imputed_near_transports: "Near transports",
        imputed_bike_room: "Bike room"
      },
      dwellings: {
        imputed_mansarde: "Mansarde",
        imputed_cellar: "Cellar",
        imputed_balcony: "Balcony",
        imputed_attique: "Attique"
      }
    },
    buildings: {
      industrial_area: "Industrial area",
      construction_date: "Construction date",
      category: "Category",
      city: "City",
      class: "Class",
      official_nb: "Official number",
      total_area: "Total area",
      egid: "EGID",
      type: "Type",
      commercial_area: "Commercial area",
      dwellings_nb: "Number of dwellings",
      area: "Ground area",
      status: "Status",
      land_use: "Land use",
      floors_nb: "Number of floors",
      office_area: "Office area",
      volume: "Total volume",
      residential_area: "Residential area"
    },
    lots: {
      municipality: "Municipality",
      sector: "Sector",
      surface: "Surface",
      type: "Type",
      land_use: "Land use",
      built_up_area: "Built-up area",
      number: "Number",
      built_up_ratio: "Built-up ratio",
      city: "City",
      label: "Label",
      egrid: "EGRID"
    },
    dwellings: {
      floor: "Floor",
      rooms_nb: "Rooms number",
      city: "City",
      category: "Category",
      land_use: "Land use",
      construction_date: "Construction date",
      status: "Status",
      ewid: "EWID",
      egid: "EGID",
      class: "Class",
      surface: "Surface area",
      type: "Type"
    }
  },
  get_building_from_group: {
    empty: {
      message: "There is no building in this group",
      title: "No building in this group"
    }
  }
};
var policy = {
  eea_rights_list: {
    objection: "Right to object to your Data's processing and withdraw consent (art. 21 GDPR),",
    access: "Right to access your Data (art. 15 GDPR),",
    forgotten: "Right to be forgotten (art. 17 GDPR),",
    complaint: "Right to lodge a complaint with an authority in your usual place of residence or work, or where an infringement occurred (art. 77 GDPR),",
    automated_decisions: "Right not to be subject to automated individual decisions (a process QUANTHOME doesn't use).",
    rectification: "Right to rectification (art. 16 GDPR),",
    processing_restriction: "Right to restrict processing upon request (art. 18 GDPR),"
  },
  data_list: {
    company_name: "The name or corporate name of the company you represent",
    first_name: "Your first name",
    phone_number: "Your phone number",
    last_name: "Your last name",
    email_address: "Your email address"
  },
  data_protection: "How does QUANTHOME protect your Data?",
  rights_exercise: "For further details or to exercise your rights, contact us at <2>contact@quanthome.com</2>.",
  data_correction: "You can contact us to know your Data, verify its accuracy, and request its completion, update, correction, or deletion as permitted by law, especially art. 32 LPD.",
  cookies: {
    types_list: {
      functional: "Functional Cookies: Improve our Site's functioning, like remembering previously viewed content or registration details. These cookies enable personalized content and save you time by not needing to register again during future visits. We also use cookies for analytics and advertising. ",
      essential: "Essential Cookies: Necessary for our website's operation.",
      statistical: "Statistical Cookies: These help us understand how visitors interact with our Site, providing information on visited pages, time spent, and any issues, such as error messages. This aids in improving our Site's performance. ",
      third_party: "Third-party Cookies: Set by third parties we use for various services (e.g., Site analysis or advertising). QUANTHOME uses Google Analytics cookies, which provide information on user activities without identifying them. Google Analytics cookies don't collect Data about Site visitors. For more about Google Analytics, click <2>https://support.google.com/analytics/answer/6004245?hl=fr</11>."
    },
    consent: "We ask for your express consent for cookie use when accessing the Site. While accepting this Policy, you can refuse cookies. You can manage cookies at any time through your browser's settings or electronic device. However, please note that some cookies are essential for the Site's function, and its use might be altered if cookies are refused or blocked. ",
    what_are_cookies: "What are cookies?",
    purpose: "We use cookies to enhance our Site's usability and functionality and to personalize or improve your browsing experience, making your next visit more pleasant. ",
    more_information: "For more information, visit <2>https://gdpr.eu/cookies/</2>. Also, check your browser or electronic device's help section for specific instructions on managing cookies.",
    types: "What types of cookies are used? ",
    usage: "Why and how do we use cookies?",
    types_overview: "The cookies we use include:",
    definition: "Cookies are small text files placed on your computer by websites you visit. They are widely used to ensure sites function or work more efficiently, and to provide information to site owners. Cookies might automatically process Data on your device and/or transfer Data about you to the site owner or third parties. You can manage the Site's cookies. "
  },
  retention_request: "You can request QUANTHOME to retain your Data for potential future registration or to continue receiving our newsletter.",
  consent: "If the reasons above aren't seen as legitimate, you consent to the processing of the Data for the mentioned purposes by accepting this Policy.",
  personal_data_definition: "Personal data ('Data') refers to any information relating to an individual. Such data can either directly identify you (e.g., your name, email address, or social security number) or do so indirectly by combining various information about you (e.g., your computer's IP address, your credit card, or phone number).",
  access_right: "Unless otherwise provided by applicable law, you have the right to know if we process Data concerning you at any time and exercise your access right per art. 25 LPD.",
  data_usage: {
    contact_information: "Your address, email, and phone number allow us to contact you. These are required for product sales. When used for newsletters or promotional communication, it's based on your consent.",
    cookies_analytics: "Data transmitted by Site cookies is for internal analytics and advertising. This is based on our legitimate interest and your consent when required by law.",
    payment_verification: "Your bank details validate your payment for products. This is contractually required.",
    account_creation: "Your name, last name, and, if applicable, your company's name, to create your account and allow you access to the Site and order products. This is contractually required.",
    legal_compliance: "All transmitted Data can be processed to comply with legal obligations and other legal imperatives",
    legal_age_verification: "Your birth date ensures you're of legal age to enter contracts with us. This is based on our legitimate interest."
  },
  eea_representative: "Our representative in the EEA is [to be completed]. The following guidelines apply to any data you provide to QUANTHOME.",
  processing_methods: "We may process your Data either automatically or manually, always implementing suitable security measures.",
  why_collect_data: "Why does QUANTHOME collect this Data?",
  your_rights: "What rights do you have regarding your Data?",
  law_compliance: "We process your Data in compliance with applicable laws, especially Swiss and European data protection laws, adopting measures to prevent unauthorized access, disclosure, alteration, or destruction.",
  data_handling: "How does QUANTHOME handle your Data?",
  retention_period: "QUANTHOME retains your Data only as long as necessary, typically 3 years after your last contact with QUANTHOME. Due to our legal obligations, some data, especially those related to our contractual relationship, must be retained for at least 10 years.",
  data_hosting: "Where is your Data hosted?",
  terms_invitation: "We also invite you to review our Terms of Use and our End User License Agreement",
  credential_safety: "To protect your Data's confidentiality, you must keep your credentials safe and not disclose them to anyone. You are responsible for any use of services offered on the Site using your credentials.",
  data_sharing: "Who might QUANTHOME share your Data with?",
  consent_withdrawal: "If we rely on your consent to process your Data, we'll seek your free and specific consent, providing clear instructions. You can revoke your consent at any time. You also have the right to request the portability of your automatically processed Data based on your consent or contractual necessity.",
  cookies_section: "Cookies",
  non_identifying_data_use: "Further non-identifying data, including aggregated or anonymized data, might be used to manage services, improve customer relations, diagnose technical issues, and gather aggregated demographic information",
  data_provided: "Data that QUANTHOME automatically collects when you access the Site or that you voluntarily provide when creating an account or later, during orders (fields marked with an asterisk are required, and additional fields can be provided optionally):",
  introduction: "Your privacy matters to us. As the data controller, Quanthome SA is committed to processing the personal data you share with us transparently and in accordance with applicable law.",
  rights_overview: "You have the right to know and request the deletion, correction, or updating of the Data we process about you.",
  legal_updates: "Updating legal information.",
  third_party_security: "We also endeavor to ensure any third party your Data might be shared with (as described above) handles it securely, maintaining its confidentiality and integrity.",
  sharing_list: {
    corporate_events: "In mergers, acquisitions, or restructuring events, or possible bankruptcy procedures, your Data might be transferred to third parties as an asset of QUANTHOME. We'll strive to inform you of such transfers beforehand, but cannot guarantee an opt-out",
    service_execution: "With any third party necessary for service execution (e.g., employees, affiliated companies, payment providers, logistic companies, our hosting provider, and IT personnel).",
    legal_requirements: "With any third party legally required due to a directive from judicial or governmental authorities or in compliance with our legal obligations."
  },
  legal_processing_objection: "You also have the right to request we stop any specific processing of Data obtained or processed in violation of the law and object to any Data processing for legitimate reasons.",
  security_measures: "QUANTHOME strives to ensure your Data's security, preventing any unauthorized access, use, modification, or disclosure.",
  company_info: "Quanthome SA, hereinafter referred to as 'QUANTHOME', 'we', or 'our', is a public limited company registered in the commercial register of the Canton of Vaud, located at Avenue de Mon-Repos 24, 1005 Lausanne, Switzerland.",
  agreement: 'By accessing the website <1>www.quanthome.com</1> ("Site"), which we operate, you expressly agree to our processing your data in accordance with this Policy.',
  eea_rights: "If you are an EEA resident, you specifically have the following rights:",
  what_is_personal_data: "What is Personal Data?",
  data_retention: "How long does QUANTHOME keep your Data?",
  hosting_details: "Data collected by QUANTHOME is hosted in Switzerland and processed by Infomaniak",
  updates: "We reserve the right to make changes and corrections to these provisions. Please check this page regularly for updates and new information. ",
  title: "Privacy Policy",
  type_of_data: "What type of Data do you provide to QUANTHOME?",
  data_processing_basis: "We process your Data based on legitimate reasons specified below, or based on your consent:",
  policy_date: "This privacy policy (the 'Policy') is dated September 30, 2023. It may be reviewed regularly (see article 11).",
  data_deletion_request: "If you want us to delete your Data from our systems, send a request to the contact below, which we'll comply with unless we need to keep your Data for legal reasons or another legitimate purpose.",
  sharing_overview: "QUANTHOME may share your Data as follows:",
  security_breach_protocol: "Please inform us immediately of any suspected or confirmed misuse of your credentials. Remember, no security measure is foolproof",
  anonymization_alternative: "Instead of destroying or deleting your Data, QUANTHOME might permanently anonymize it, making identification impossible",
  additional_information: "Any personal information you spontaneously share with us in email exchanges; Any other Data collected by cookies and the web server. More details about automatically collected Data can be found in article 10 of the Policy",
  international_transfers: "In some circumstances, especially for technical reasons, your Data might be transferred outside Switzerland or the European Union. In such cases, third parties will guarantee adequate measures ensuring the legal requirements and protection of your rights are met.",
  transfer_consent: "By accessing the Site and sharing Data, you expressly consent to such transfers.",
  anonymization_use: "We might process your Data to remove identifiable information (anonymization), then using this anonymous data for purposes not outlined in the Policy (e.g., comparative analysis, campaign targeting, or developing and marketing new services)",
  data_provision_consequences: "You have no legal or contractual obligation to provide us with Data. However, refusing to provide certain Data or exercising the rights mentioned in this article 9 might prevent us from providing you our products, including Site access. ",
  inquiries: "For any inquiries regarding this Policy or your data's use, please contact us at <2>contact@quanthome.com</2> or call +41 21 312 16 93."
};
var boarding_page = {
  login: {
    abort: "Cancel",
    aal2: {
      forgot_button: "Use recovery codes",
      subtitle: "Please complete the second authentication challenge.",
      submit_button: "Submit",
      title: "Enter OTP (One-time password)"
    },
    aal1: {
      submit_button: "Login",
      forgot_button: "Forgot/Reset password?",
      title: "Login to your account",
      subtitle: "Welcome back!"
    },
    missing_otp: {
      title: "Invalid OTP Setup",
      description: "The One-time Password (OTP) for this account is not configured or is incorrect. It the problem persists, please contact your admin to resolve the issue."
    },
    failed: {
      title: "Error while logging"
    }
  },
  show_recovery: {
    button: {
      download: "Download",
      regenerate_code: "Generate new recovery codes",
      copied: "Copied",
      proceed: "Proceed",
      copy: "Copy",
      print: "Print"
    },
    warning: "Keep your recovery code in a safe spot. These codes are the last resort for accessing your account in case you lose your second factor. If you cannot find this code, <0>you will lose</0> access to the account.",
    explain: {
      regenerate_code: "When you generate new recover codes, you must download or print the new codes. Your old codes won\u2019t work anymore."
    },
    label: {
      regenerate_code: "Generate new recovery codes"
    },
    title: "Recovery code",
    subtitle: "Never lose your recovery code."
  },
  otp: {
    subtitle: "Dual factor authenticator to best protect data.",
    step: {
      type_code: "When OTP ready, verify by typing your TOTP",
      scan_qr: "Scan this QR code to set your trusted device via your OTP app",
      trusted_device: "Open your favorite OTP app on your trusted device"
    },
    button: {
      abort: "Will do that later",
      verify: "Verify my device with TOPT"
    },
    legend: "(T)OTP*: (Time-based) One Time Password",
    failed: {
      title: "Error while setting OTP device"
    },
    title: "Setting your OTP"
  },
  verify_mail: {
    step: {
      choose_method: {
        description: "Type your email address to verify it",
        success: {
          message: "An email to finish your verification has been sent to you",
          title: "Code sent"
        },
        subtitle: "Verify your email address",
        button: "Send code"
      },
      sent_email: {
        subtitle: "Verify your email address",
        button: "Verify code",
        description: "Write the code you just received by email",
        success: {
          message: "You're email is now verified",
          title: "Verification complete"
        }
      }
    },
    abort: "Will do that later",
    title: "Finish your setup"
  },
  forgot_password: {
    last_step: "You can now change your password for a new one:",
    button: {
      send: "Send my code",
      cancel: "Cancel recovery",
      save: "Save my password",
      verify: "Verify my code"
    },
    subtitle: "Don\u2019t panic, everything will be fine...",
    success: {
      title: "Password changed successfully",
      message: "You can now log in with your new password."
    },
    title: "Forgot your password",
    check_code_from_email: "A recovery code has been sent to your email\u2026"
  },
  recovery_code: {
    form: {
      button: "Verify"
    },
    title: "Two-factor recovery",
    abort_button: "Cancel",
    faq: {
      what_is_recovery: {
        question: "What is a recovery code?",
        answer: "Recovery code is the code you received when you bind your device for the first time. You should have kept it somewhere safe."
      },
      lock: {
        question: "Locked out?",
        answer: "Please contact your admin for recovery."
      },
      description: "If your are unable to access your mobile device, enter your recovery code to verify your identity."
    },
    reset: {
      success: {
        message: "You can now bind a new device.",
        title: "Recovery code is correct"
      }
    },
    missing: {
      description: "The recovery code for this account is not defined or has expired. Please contact the support of Quanthome to resolve the issue.",
      title: "Invalid recovery code"
    }
  },
  register: {
    notification: {
      changed_email: {
        message: "Your information have been updated successfully - You should have received a new email to verify your new email address.",
        title: "Email address changed"
      },
      privileged_session_reached: {
        message: "For security reason, the registration process needs to be completed within 30 minutes. Please request another invitation link to start over the registration.",
        title: "Privileged session time out"
      },
      flow_expiration: {
        message: "The flow has expired - Contact your administrator.",
        title: "Expired"
      }
    },
    button: "Save",
    title: "Welcome to Quanthome_",
    repeat_password: "Repeat password",
    error: {
      repeat_password: "Passwords must be identic"
    },
    subtitle: "Setup your account:"
  },
  totp_setup: {
    notification: {
      privileged_session_reached: {
        message: "Privileged session time out. Please login again."
      }
    }
  }
};
var global = {
  chart: {
    legend: {
      gav: "GAV",
      r_debt_ratio: "Debt ratio",
      r_rental_losses: "Rental losses",
      total_idc: "Total Energy",
      market_market_cap: "Market cap",
      transport_tram: "Transport tram",
      realised_gains_losses: "Realised gains/losses",
      long_term_interest_bearing_mortgages: "Long term interest bearing mortgages",
      estimated_co_2_scope_1_2_33: "Total CO\u2082 scope 1 + 2 + 3",
      market_share_price: "Share price",
      r_market_value: "Market value of buildings",
      estimated_total_market_value: "Total market value",
      offices: "Offices",
      revenues: "Revenues",
      total_net_asset: "Total net asset",
      restaurants: "Restaurants",
      idc_per_m_2: "Energy intensity",
      r_nav_before_distribution: "NAV before distribution",
      shops: "Shops",
      r_market_cap: "Market cap",
      co_2_scope_1_2_33_per_m_2: "CO\u2082 scope 1 + 2 + 3.3",
      r_cost_price: "Cost price of buildings",
      roa: "ROA",
      other: "Other",
      estimated_total_net_rent: "Total net rent",
      reported_total_target_rent: "Total target rent",
      co_2_listed: "CO\u2082",
      region_lemanique: "R\xE9gion l\xE9manique",
      total_income: "Total income",
      reported_ebit_margin: "Ebit margin",
      short_term_liabilities: "Short term liabilities",
      total_properties: "Total properties",
      nordwestschweiz: "Nordwestschweiz",
      commercial: "Commercial",
      mixed: "Mixed",
      estimated_co_2_scope_1_2_33_per_m_2: "CO\u2082 scope 1 + 2 + 3",
      secondary_education: "Secondary education",
      co_2_scope_2_per_m_2: "CO\u2082 scope 2",
      cultural_venues: "Cultural venues",
      r_ebit_margin: "Ebit margin",
      r_total_target_rent: "Total target rent",
      public_open_space: "Open space",
      purchased: "Purchased buildings",
      c_market_value: "Market value of buildings",
      total_co_2_scope_1_2_33: "Total CO\u2082 scope 1 + 2 + 3.3",
      reported_rental_losses: "Rental losses",
      r_total_real_rent: "Total real rent",
      none: "No heating",
      nav: "NAV",
      asset: "Asset",
      r_total_cost_price: "Total cost price",
      very_low: "Very low",
      primary_education: "Primary education",
      medium: "Medium",
      net_income: "Net income",
      r_target_rent: "Target rental income",
      r_tga_before_distribution: "TGA before distribution",
      equity: "Equity",
      r_real_rent: "Real rent",
      legend: "Legend",
      liabilities: "Liabilities",
      r_payout_ratio: "Payout ratio",
      co_2_scope_1_per_m_2: "CO\u2082 scope 1",
      reported_dividend_yield: "Dividend yield",
      rent_listed: "Rental income",
      date: "Date",
      transport_bike: "Transport bike",
      r_total_market_value: "Total market value",
      rural: "Rural",
      reported_total_cost_price: "Total cost price",
      c_net_rent: "Rental income",
      amount: "Amount",
      benchmark_fund: "Benchmark fund",
      urban: "Urban",
      tessin: "Ticino",
      realised_income: "Realised income",
      reported_total_market_value: "Total market value",
      rent_expected: "Rental income (expected)",
      intermediate: "Intermediate",
      sold: "Sold buildings",
      ordinary_income_carried_forward: "Ordinary income carried forward",
      default: "Amount",
      estimated_total_energy: "Total energy",
      ostschweiz: "Ostschweiz",
      very_high: "Very high",
      total_co_2_scope_33: "Total CO\u2082 scope 3.3",
      total_co_2_scope_1_2: "Total CO\u2082 scope 1 + 2",
      reported_roe: "ROE",
      r_dividend_yield: "Dividend yield",
      estimated_energy_intensity: "Energy intensity",
      short_term_interest_bearing_mortgages: "Short term interest bearing mortgages",
      other_long_term_liabilities: "Other long term liabilities",
      sports_recreation: "Sports recreation",
      current_building: "Current building",
      r_roe: "ROE",
      transport_bus: "Transport bus",
      plots: "Plots",
      reported_tga_before_distribution: "TGA before distribution",
      high: "High",
      m_market_cap: "Market cap",
      early_years: "Early years",
      estimated_co_2_scope_1_2: "Total CO\u2082 scope 1 + 2",
      reported_total_real_rent: "Total real rent",
      current_fund: "Current fund",
      reported_payout_ratio: "Payout ratio",
      zentralschweiz: "Zentralschweiz",
      healthcare: "Healthcare",
      total_co_2_scope_1: "Total CO\u2082 scope 1",
      non_fossil: "Non fossil",
      other_short_term_liabilities: "Other short term liabilities",
      total_co_2_scope_2: "Total CO\u2082 scope 2",
      reported_tna_before_distribution: "TNA before distribution",
      residential: "Residential",
      fossil: "Fossil",
      reported_nav_before_distribution: "NAV before distribution",
      r_tna_before_distribution: "TNA before distribution",
      expenses: "Expenses",
      zurich: "Z\xFCrich",
      co_2_expected: "CO\u2082 (expected)",
      espace_mitelland: "Espace Mitelland",
      co_2_scope_1_2_per_m_2: "CO\u2082 scope 1 + 2",
      m_share_price: "Share price",
      other_asset: "Other asset",
      low: "Low",
      city_within_15_min: "City within 15 min",
      long_term_liabilities: "Long term liabilities",
      co_2_scope_33_per_m_2: "CO\u2082 scope 3.3",
      reported_debt_ratio: "Debt ratio",
      cash_holding_and_balances_at_sight: "Cash holding and balances at sight",
      surface: "Surface",
      r_share_price: "Share price",
      sustainability: "Sustainability",
      woman: "Woman",
      unrealised_gains_losses_including_liquidation_taxes_variation: "Unrealised gains/losses including liquidation taxes variation",
      man: "Man",
      net_income_available_for_distribution: "Net income available for distribution",
      estimated_co_2_scope_1_2_per_m_2: "CO\u2082 scope 1 + 2",
      aged_care: "Aged care",
      unchanged: "Unchanged buildings",
      foundation: "Foundation",
      unlisted_fund: "Unlisted fund",
      real_estate_firm: "Real estate firm",
      listed_fund: "Listed fund",
      reported_share_fossil: "Share fossil",
      computed_energy_source_heating_type_coverage: "Coverage",
      reported_co_2: "Total CO\u2082 emissions",
      reported_total_energy: "Total energy",
      reported_co_2_per_m_2: "CO\u2082 emissions",
      computed_energy_source_heating_type_non_fossil: "Share non-fossil",
      computed_energy_source_heating_type_fossil: "Share fossil",
      reported_energy_intensity: "Energy intensity",
      official_energy_intensity: "Energy intensity",
      reported_co_2_scope_1_2_per_m_2: "CO\u2082 scope 1 + 2",
      official_co_2_scope_1_2_per_m_2: "CO\u2082 scope 1 + 2"
    },
    tooltip: {
      potential: "Expected",
      real: "Listed"
    },
    export: {
      png: "png",
      excel: "xlsx",
      csv: "csv"
    },
    export_as: "Download as",
    download: "Download"
  },
  assets: {
    building: "building",
    lot: "lot",
    dwelling: "dwelling"
  }
};
var status = {
  completed: "Completed",
  not_complete: "Not completed",
  resend: "Re-send"
};
var errors = {
  fii: {
    fii_portfolio_duplicated_dwelling_id: "All dwellings are already in this portfolio.",
    fii_invalid_dwelling_id: "No valid dwelling id.",
    fii_portfolio_duplicated_building_id: "All buildings are already in this portfolio.",
    fii_invalid_building_id: "No valid building id."
  }
};
var double_range_input = {
  error_msg: "Min value should be smaller than the max.",
  year_error_msg: "Please input a valid year",
  clear: "clear",
  start: "start date",
  min: "min",
  max: "max",
  end: "end date"
};
var common = {
  connection_lost: {
    message_1: "You might not be connected to internet anymore",
    message_2: "Application cannot work as expected",
    message_3: "Please reload the page.",
    reload_button: "Reload",
    title: "Connection lost"
  },
  funds: {
    pascalcase: "Funds"
  },
  enterprise_state: {
    exempt: "Exempt",
    unpaid: "Unpaid",
    ended: "Ended",
    subscribed: "Subscribed",
    trial_end: "End of trial",
    state: "Contract type",
    examination: "Examination",
    trial: "Trial"
  },
  real_estate_firm: {
    pascalcase: "Real estate firm"
  },
  lots: {
    lowercase: "plots",
    pascalcase: "Plots"
  },
  financials: {
    array: {
      industrial: "Industrial",
      total: "Total",
      commercial: "Commercial",
      office: "Office",
      residential: "Residential"
    }
  },
  keys: "keys",
  buildings: {
    pascalcase: "Buildings",
    lowercase: "buildings"
  },
  comparables: {
    pascalcase: "Comparables"
  },
  delete_user: "Delete user",
  portfolios: {
    pascalcase: "Portfolios"
  },
  error: "Something happened",
  developer_mode: {
    deactivated: "Deactivated",
    activated: "Activated",
    state: "Developer mode"
  },
  unlisted_fund: {
    pascalcase: "Unlisted fund"
  },
  warning: "Warning",
  role: {
    manager: "Manager",
    user: "User",
    owner: "Owner"
  },
  assign_contact_user: "Assign as Contact user",
  slot: {
    institutional: "Institutional",
    investor: "Investor",
    consumer: "Consumer"
  },
  create: "Create",
  removing: "removing",
  assets: {
    pascalcase: "Assets"
  },
  transactions: {
    pascalcase: "Transactions"
  },
  warning_msg: "Operation on {{ failed }} has failed.",
  error_message: "Something happened",
  key: "key",
  cancel_button: "Cancel",
  confirm_button: "Confirm",
  notification: {
    success: {
      title: "Success"
    }
  },
  dwellings: {
    pascalcase: "Dwellings",
    lowercase: "dwellings"
  },
  listed_fund: {
    pascalcase: "Listed fund"
  },
  foundation: {
    pascalcase: "Investment foundation"
  },
  edit: "Edit",
  institutions: {
    pascalcase: "REIVs"
  },
  success: "Successful"
};
var footer = {
  license_agreement: "License Agreement",
  impressum: "Impressum",
  confidential_policy: "Confidential Policy"
};
var source_badge = {
  reported: "Reported",
  official: "Official",
  expected: "Expected",
  forecasted: "Forecasted",
  listed: "Listed",
  market_data: "Market data",
  computed: "Computed",
  estimated: "Estimated",
  quanthome_data: "Quanthome data",
  info: "Info"
};
var dashboard = {
  indicators: {
    title: "Indicators",
    switzerland_vacancy_rate: "Swiss Vacancy Rate",
    reference_interest_rate: "Reference Interest Rate",
    ipc_lik: "CPI Consumer Price Index (IPC/LIK)",
    snb_policy_rate: "Swiss National Bank Policy Rate"
  },
  indices: {
    swiss_residential_property_price: "Swiss Residential Property Price Index",
    title: "Indices",
    construction_price_index_building: "Swiss Construction Index - Building",
    construction_price_index_total: "Swiss Construction Index - Total",
    construction_price_index_civil_engineering: "Swiss Construction Index - Civil engineering"
  },
  empty: {
    portfolios: "You don\u2019t have any portfolios",
    funds: "You don\u2019t have any funds"
  },
  trend: {
    title: "Swiss market trend: net rent per m\xB2"
  },
  rent: {
    title: "Rent per m\xB2 per canton"
  },
  error: {
    feature: {
      rights: "You don\u2019t have access to this feature"
    }
  }
};
var notification = {
  terminated_session: {
    title: "Session terminated",
    message: "You might be connected on an other device or the session life time had been reached."
  }
};
var administration = {
  companies: {
    actions: {
      delete_company: "Delete company",
      update_company_slots: "Update company slots",
      update_company: "Edit company settings"
    },
    col_name: {
      contact_user: "Contact user",
      developer_mode: "Developer mode",
      total_consumer_seat: "Total consumer seats",
      days_left: "Days left",
      free_investor_seat: "Investor seats left",
      consumer_users: "Consumer users",
      contact_user_email: "Contact user email",
      free_institutional_seat: "Institutional seats left",
      used_investor_seat: "Investor used seats",
      related_am: "Related account manager",
      all_users: "Team members",
      license_use: "License use",
      total_all_seats: "Total seats",
      state: "Contract type",
      subscription_start: "Subscription date",
      free_consumer_seat: "Consumer seats left",
      used_consumer_seat: "Consumer used seats",
      name: "Company",
      institutional_users: "Institutional users",
      used_institutional_seat: "Institutional used seats",
      used_all_seats: "Total used seats",
      investor_users: "Investor users",
      contact_user_phone: "Contact user phone number",
      total_investor_seat: "Total investor seats",
      expiration_date: "Contract end date",
      total_institutional_seat: "Total institutional seats"
    },
    headers: {
      companies_count: "{{count}} Companies",
      member_count: "{{ count }} members"
    },
    cells: {
      user_count: "{{ count }} users"
    },
    teams: "teams",
    table_title: "Companies"
  },
  breadcrumb: {
    edit: "Edit",
    create_company: "Create",
    details: "Details",
    companies: "Companies"
  },
  collaborators: {
    headers: {
      members_count: "{{ count }} Members "
    }
  }
};
var management = {
  nav: {
    profile: {
      title: "Profile",
      subtitle: "Update your profile settings."
    },
    connections: {
      title: "API",
      subtitle: "Create and manage API keys to access quanthome data from an operating system, application, or other service."
    },
    seats: {
      subtitle: "Here is everything you need to know about seats and billing",
      title: "Seats"
    },
    collaborators: {
      subtitle: "Here is all you need to know about the people accessing the platform in your company.",
      title: "Collaborators"
    },
    organization: {
      subtitle: "Here are all the information about the company you are working in.",
      title: "Organization"
    },
    requests: {
      subtitle: "All requests will be gathered here.",
      title: "Requests"
    },
    edit_company: {
      subtitle: "Update information of a company",
      title: "Update company"
    },
    preferences: {
      subtitle: "Manage your preferences",
      title: "Preferences"
    },
    security: {
      subtitle: "Manage your password to access the platform.",
      title: "Security"
    },
    users: {
      subtitle: "All users of all companies are gathering here.",
      title: "Users"
    },
    companies: {
      subtitle: "Here are all the companies subscribing to the platform.",
      title: "Companies"
    },
    create_company: {
      subtitle: "Set up a new company by providing most of its information",
      title: "New company"
    },
    teams: {
      subtitle: "Here is all you need to know about the people accessing the platform in your company.",
      title: "Teams"
    },
    language: {
      title: "Language"
    },
    company: {
      title: "Company",
      subtitle: "Manage members & seat of an enterprise."
    },
    languages: {
      subtitle: "Manage your langages"
    },
    contracts: {
      title: "Contracts"
    }
  },
  email: {
    addresses: {
      description: "Do it one by one or past a list of emails separated by a coma and validate with enter",
      title: "Email addresses",
      empty: "Your users will be displayed here"
    }
  },
  header: {
    gotoplatform: "Go to the platform",
    logout: "Log out"
  },
  category: {
    administration: {
      title: "Administration"
    },
    team: {
      title: "Team"
    },
    company: {
      title: "Company"
    },
    customers: {
      title: "Customers"
    },
    personal: {
      title: "Personal"
    },
    communication: {
      title: "Communication"
    }
  }
};
var action = {
  portfolios: {
    name: {
      change_success: {
        message: "You successfully changed the portfolio name",
        title: "Name has been changed"
      }
    },
    remove: {
      loading: {
        message: "Removing {{ asset }}(s) from your portfolio"
      },
      confirmation: {
        title: "Remove from portfolio",
        question: "Are you sure that you want to remove the asset from this portfolio?"
      }
    }
  },
  label: {
    create_key: "Create key",
    invite_member: "Add member",
    delete: "Delete",
    create_user: "Create user"
  },
  companies: {},
  users: {
    remove: {
      confirmation: {
        question: "Are you sure you want to remove these users?"
      }
    }
  }
};
var panel_selection = {
  option: {
    computed_road_accessibility_distribution: "By road",
    typology: "Typology",
    market_value: "Market value",
    rental_space: "Area",
    actual_rental_status_real: "Real rental status",
    reported_type: "Type",
    region: "Region-Canton",
    type: "Type-Category",
    actual_market_value: "Market value",
    class: "Class",
    real_rent: "Real rent",
    potential_net_rent: "Net rent",
    cost_price: "Cost price",
    potential_market_value: "Market value",
    computed_pt_accessibility_distribution: "By public transportation",
    area: "Area",
    actual_rental_status_target: "Target rental status",
    target_rent: "Target rent"
  },
  title: {
    group: "Grouping",
    weight: "Weighting"
  }
};
var watchlist = {
  dwellings: {
    empty: "No dwellings watchlist"
  },
  buildings: {
    empty: "No buildings watchlist"
  }
};
var treemap = {
  label: {
    value: "Value",
    percentage: "Percentage",
    label: "Label"
  },
  unit: {
    percentage: "%"
  }
};
var line_chart = {
  placeholder: {
    no_data_selected: "Please select data to display"
  }
};
var fund = {
  financials: {
    accounting: {
      table_action: {
        download: "Download accounting table"
      }
    }
  },
  overview: {
    benchmark: {
      delete: "Delete benchmark"
    }
  }
};
var playground = {
  display: {
    map: "Display map",
    table: "Display table",
    filter: "Display filter",
    chart: "Display chart"
  },
  chart: {
    message: {
      select_to_start: "Please configure the chart first"
    }
  },
  screener: {
    message: {
      select_to_start: "Please configure the screener"
    }
  },
  chart_selections: {
    launch: "Launch",
    clear: "Clear"
  }
};
var buildings = {
  type: {
    residential: "Residential",
    mixed: "Mixed",
    commercial: "Commercial"
  },
  social: {
    transport_accessibility: {
      transport_accessibility: {},
      road_accessibility: {}
    }
  }
};
var option = {
  sudo: "Sudo",
  institutional: "Institutional",
  am: "Account manager",
  owner: "Owner",
  admin: "Admin",
  user: "User",
  manager: "Manager",
  no_plan: "No plan",
  consumer: "Consumer",
  triage: "Triage",
  investor: "Investor"
};
var potfolios = {
  sections: {
    description: {
      title: "Description"
    },
    assets: {
      title: "Inventory"
    },
    environmental: {
      title: "Environmental"
    },
    social: {
      title: "Social"
    },
    financials: {
      title: "Financials"
    }
  },
  tiles: {
    revenue: {
      title: "Revenue"
    },
    charges: {
      title: "Charges"
    },
    evolution: {
      title: "Evolution"
    }
  },
  widget: {
    charges: {
      title: "Charges"
    },
    revenue: {
      title: "Revenue"
    }
  }
};
var error = {
  something_went_wrong: {
    title: "Something went wrong"
  },
  notfound: {
    button: "Go back",
    code: "Error 404",
    subtitle: "Sorry, the page you are looking for doesn't exist.",
    title: "Page not found"
  },
  email: {
    format: "Your email is not well written"
  }
};
var screener_bar = {
  main_button: {
    launch: "Launch",
    screener: "Screener"
  }
};
var traits = {
  contact: {
    office_phone: "Business phone number"
  },
  name: {
    last: "Last name",
    first: "First name"
  },
  email: "Email address"
};
var table = {
  empty: "No data (yet) we are working on it \u{1F3C3}",
  fund_type: {
    commercial: "Commercial",
    mixed: "Mixed",
    residential: "Residential"
  },
  error: "An error occurred \u{1F647}",
  fund_legal_form: {
    foundation: "Foundation",
    listed_fund: "Listed fund",
    real_estate_firm: "Real estate firm",
    unlisted_fund: "Unlisted fund"
  },
  back_office_empty: "Empty table",
  empty_filtered_result: "Configured screen leads to empty data, please adjust your filters."
};
var users = {
  role: {
    user: "User"
  },
  roles: {
    triage: "Triage",
    owner: "Owner"
  }
};
var multiple_select = {
  placeholder: {
    search: "Search"
  },
  clear: "clear",
  not_enough_selected: {
    error: "A minimum of {{count}} selections are required."
  },
  select_all: "Select all"
};
var table_actions = {
  request_download: {
    accounting: "Download accounting table",
    csv: "Download selected rows on current page",
    header: "Download as"
  },
  watchlist: {
    remove: {
      button: {
        label: "Remove selected assets from watchlist"
      }
    },
    add: {
      button: {
        label: "Follow selected assets"
      }
    }
  },
  portfolios: {
    remove: {
      confirmation: {
        title: "Remove selected assets from current portfolio"
      }
    }
  },
  add_to_portfolios: {
    title: "Add selected assets to portfolio"
  }
};
var candle_stick_chart = {
  label: {
    volume: "Volume",
    low: "Low",
    open: "Open",
    close: "Close",
    start_date: "Beginning",
    high: "High",
    end_date: "Ending",
    turnover: "Turnover",
    date: "Date"
  },
  unit: {
    chf: "CHF",
    units: "Units"
  }
};
var header = {
  dropdown_menu: {
    profile: "My Profile",
    logout: "Logout",
    settings: "Settings",
    my_company: "My company",
    back_office: "Administration"
  },
  navbar: {
    funds: "REIVs",
    dashboard: "Dashboard",
    playground: "Playground",
    portfolios: "Portfolios",
    institutions: "REIVs",
    screener: "Real estate",
    watchlist: "Watchlist",
    map: "Map"
  }
};
var paywall = {
  subtitle: "Please contact your Account manager.",
  message: {
    no_slot: "You currently have no right to use the application.",
    end_trial: "Your trial ended.",
    out_of_scope: "This feature is out of your enterprise subscription.",
    error: "There is an error with your subscription.",
    slot_out_of_scope: "This feature is not included in your permission slots."
  },
  button: {
    logout: "Logout"
  }
};
var tile = {
  side_menu: {
    meter: "Meters",
    country: "Country",
    minute: "Minutes",
    municipality: "Municipality",
    canton: "Canton"
  },
  wrong: {
    message: "Something wrong happens"
  },
  empty: {
    message: "Missing data"
  }
};
var gradient = {
  label: {
    low: "LOW",
    high: "HIGH"
  },
  quartile_1: "1st quartile",
  quartile_2: "Median",
  chart: {
    no_data: "No data"
  },
  quartile_3: "3rd quartile"
};
var companies = {
  notifications: {
    success_delete_enterprises: "Companies successfully deleted",
    success_create_users: "Users successfully created",
    no_slot_available: "No slots available"
  },
  button: {
    give_am_rights: "Give am rights",
    give_default_roles: "Give default roles",
    clear_fund_cache: "Clear fund cache",
    check_states: "Check states",
    clear_all_cache: "Clear all cache",
    clear_cache: "Clear cache",
    refresh_roles: "Refresh roles"
  },
  modal: {
    confirm_delete: {
      text: "Are you sure you want to delete this/these company(ies)?",
      title: "Confirm to delete"
    }
  }
};
var password = "New password";
var unsaved_screener = {
  tooltip: {
    save_button: "Save your unsaved changes with this save button"
  },
  button: {
    leave_page: "Proceed without saving",
    back_to_screener: "Go back to screener"
  },
  warning: {
    content: "You have an ongoing unsaved screen."
  },
  modal: {
    title: "You are about to leave the screener page"
  }
};
var profile_train = {
  tooltip: {
    more: "{{count}} more"
  }
};
var unit = {
  chf_per_m2: "CHF/m\xB2"
};
var pyramid_chart = {
  label: {
    group: "Group",
    unit: "%",
    age: "Age",
    man: "Man",
    woman: "Woman",
    percentage: "Percentage"
  }
};
var download = {
  action_label: "Download CSV",
  request_created: "Request created."
};
var search = {
  nothing_found: "Nothing found",
  placeholder: "Addresses",
  title: "Search result",
  type_to_search: "Type to search"
};
var overview = {
  property: {
    listed_fund: "Listed fund",
    foundation: "Foundation property",
    unlisted_fund: "Unlisted fund",
    mixed: "Institutional property",
    real_estate_firm: "Real estate firm"
  }
};
var valuations = {
  actions: {
    reset: "Reset"
  }
};
var general = {
  app_wall: {
    redirect: {
      message: "You don't have access to the app currently. We will redirect you to the settings\u2026"
    }
  }
};
var preset = {
  modal: {
    confirm_delete: {
      title: "Delete screen",
      text: "Are you sure you want to delete this screen?",
      proceed: "Proceed",
      cancel: "Back"
    }
  }
};
var time_selector = {
  header: "Period",
  min: "Data from"
};
var benchmark_selector = {
  search: {
    placeholder: "Institution name"
  },
  header: "Compare with"
};
var impressum = {
  mail: "E-mail address:",
  text: "Impressum Quanthome SA uses the website app.quanthome.com to provide data on every real",
  address: "Postal address: Avenue Mon-Repos 24, 1005 Lausanne"
};
var widget = {
  side_menu: {
    municipality: "Municipality",
    country: "Country",
    canton: "Canton"
  }
};
var portfolio = {
  environmental: {
    evolution: {
      title: "Evolution"
    }
  }
};
var view = {
  switch: {
    cards: "See cards",
    table: "See table"
  }
};
var input = {
  select: "select",
  edit: "edit"
};
var single_select = {
  clear: "clear"
};
var badge = {
  beta: "Beta feature"
};
var boarding = {
  suggested_otp: "Suggested OTP app:"
};
var items = {
  array: {
    columns: {
      title: {
        potential: "Estimated",
        real: "Reported / Listed",
        difference: "Difference"
      }
    }
  },
  charts: {
    gradient: {
      subject: {
        indice: "Indice",
        index: "Index"
      }
    }
  }
};
var entity_selector = {
  search: "Search",
  button: {
    cancel: "Cancel",
    save: "Save changes"
  }
};
var inputs = {
  placeholder: {
    preset_name: "Preset name",
    input_name: "Input name",
    choose_option: "Choose an option"
  }
};
var login = {
  error: "Error while logging"
};
var empty_chart = {
  message: "No data"
};
var chart_selections = {
  chart_type: "Chart type",
  timespan: "Time span",
  bin_nb: "Bin number",
  y_axis: "Y axis",
  fields: "Fields",
  relative: "Show relative value",
  x_axis: "X axis",
  value: "Value",
  size: "Size",
  group_by: "Group by",
  base_100: "Show as base 100",
  benchmarks: "Benchmarks",
  color_by: "Color by",
  selected_targets: "Groups to display",
  selected_targets_optional: "Groups to display",
  selected_target_bars: "Bars to display"
};
var number_input = {
  placeholder: "Input number"
};
var scatter_chart = {
  filtered_result: "Filtered result"
};
var histogram_chart = {
  tooltip: {
    bound: "Bounding box",
    count: "Count"
  }
};
var chart = {
  filtered_asset_average: "Average of filtered assets",
  filtered_asset: "Filtered asset",
  filtered_asset_sum: "Sum of filtered assets"
};
var en_default = {
  setting,
  units,
  license_agreement,
  funds,
  screener,
  actions,
  table_header,
  highlight,
  asset_page,
  modal,
  income_statement,
  balance_sheet,
  portfolios,
  asset,
  policy,
  boarding_page,
  global,
  status,
  errors,
  double_range_input,
  common,
  footer,
  source_badge,
  dashboard,
  notification,
  administration,
  management,
  action,
  panel_selection,
  watchlist,
  treemap,
  line_chart,
  fund,
  playground,
  buildings,
  option,
  potfolios,
  error,
  screener_bar,
  traits,
  table,
  users,
  multiple_select,
  table_actions,
  candle_stick_chart,
  header,
  paywall,
  tile,
  gradient,
  companies,
  password,
  unsaved_screener,
  profile_train,
  unit,
  pyramid_chart,
  download,
  search,
  overview,
  valuations,
  general,
  preset,
  time_selector,
  benchmark_selector,
  impressum,
  widget,
  portfolio,
  view,
  input,
  single_select,
  badge,
  boarding,
  items,
  entity_selector,
  inputs,
  login,
  empty_chart,
  chart_selections,
  number_input,
  scatter_chart,
  histogram_chart,
  chart
};

export {
  setting,
  units,
  license_agreement,
  funds,
  screener,
  actions,
  table_header,
  highlight,
  asset_page,
  modal,
  income_statement,
  balance_sheet,
  portfolios,
  asset,
  policy,
  boarding_page,
  global,
  status,
  errors,
  double_range_input,
  common,
  footer,
  source_badge,
  dashboard,
  notification,
  administration,
  management,
  action,
  panel_selection,
  watchlist,
  treemap,
  line_chart,
  fund,
  playground,
  buildings,
  option,
  potfolios,
  error,
  screener_bar,
  traits,
  table,
  users,
  multiple_select,
  table_actions,
  candle_stick_chart,
  header,
  paywall,
  tile,
  gradient,
  companies,
  password,
  unsaved_screener,
  profile_train,
  unit,
  pyramid_chart,
  download,
  search,
  overview,
  valuations,
  general,
  preset,
  time_selector,
  benchmark_selector,
  impressum,
  widget,
  portfolio,
  view,
  input,
  single_select,
  badge,
  boarding,
  items,
  entity_selector,
  inputs,
  login,
  empty_chart,
  chart_selections,
  number_input,
  scatter_chart,
  histogram_chart,
  chart,
  en_default
};
